import React, {useState} from 'react';
import {Flex, Col, Row, Text, Image} from '../common/plain';
import {ScrapBox, Slide} from './components';
import finance_scrap from '../../images/finance_scraps_black.png';

const data = [
    {
        src: "https://imgnews.pstatic.net/image/018/2021/06/09/0004951700_001_20210609083002144.jpg",
        title: "[외환브리핑]영국 정상화 연기 파운드화 약세, 달러 반등..환율, 1120원 탈환 시도",
        date: "2021.06.09",
        description: `미 국채 금리 1.5%대, 달러인덱스 90포인트
        영국 정부 코로나19 경제정상화 2주 연기 검토
        국내 증시 외국인 투자심리 부진 등 달러화 강세
        [이데일리 이윤화 기자] 영국 정부가 현지시각 오는 21일로 계획했던 코로나19 봉쇄해제 시점을 2주 이상 미루는 방안을 검토 중인 것으로 알려지면서 파운드화가 약세로 전환했고, 달러화가 반등했다. 10일(현지시간) 미국의 5월 소비자물가지수(CPI) 발표를 앞두고 시장이 관망세를 보이면서 위험선호 회복이 부진했고, 국내증시에서도 외국인 매도세가 이틀 연속 이어지면서 원화 하락 압력이 커졌다. 이에 원·달러 환율은 전일에 이어 상승하면서 1120원 탈환을 시도할 것으로 보인다. 다만, 조선사들의 중공업 수주와 이월 네고(달러 매도) 물량에 대한 경계감에 1110원대 후반으로 등락할 전망이다. 
        9일 서울외국환중개에 따르면 간밤 뉴욕차액결제선물환(NDF) 시장에서 거래된 원·달러 1개월물은 1117.25원에 최종 호가됐다. 최근 1개월물 스와프포인트(-0.15원)를 고려하면 이날 환율은 전 거래일 종가(1114.2원)보다 3.2원 가량 상승 출발할 것으로 보인다. 
        
        미 10년물 금리는 1.5%대를 등락하며 하향 안정을 보이고 있지만 달러화는 영국 정상화 연기 소식에 소폭 반등했다. 10년물 금리는 1.5%대, 달러인덱스는 90포인트 초반대에서 등락하고 있다. 8일(현지시간) 오후 7시께 10년물 국채 금리는 전일 대비 0.001%포인트 오른 1.569%를 기록하고 있다. 달러인덱스는 뉴욕증시 종가 수준보다 0.069%포인트 오른 90.141을 기록하고 있다. 
        
        영국은 최근 변이 바이러스 확산세에 오는 21일로 계획했던 코로나 19 봉쇄해제 시점을 2주 이상 미루는 방안을 검토하고 있다. 영국 정부의 의학 고문들은 지난 7일 각료들에게 최근 상황을 브리핑하면서 상당히 암울하다고 표현한 것으로 알려졌다. 
        
        미국 뉴욕 증시는 전일에 이어 혼조세로 마감했다. 5월 소비자물가지수(CPI) 발표에 따라 당장 이번달 연방준비제도(Fed) 연방공개시장위원회(FOMC) 정례회의 때부터 테이퍼링(채권 매입 축소) 논의를 진행할 수 있다는 불안감에 방향성을 잡지 못하고 있다. 8일(현지시간) 마켓포인트에 따르면 이날 미국 뉴욕증권거래소에서 다우존스 30 산업평균지수는 전거래일 대비 0.09% 내린 3만4599.82에 거래를 마쳤다. 반면 스탠더드앤드푸어스(S&P) 500 지수는 0.02% 상승한 4227.26에 마감했다. 기술주 중심의 나스닥 지수는 0.31% 뛴 1만3924.91을 나타냈고, 중소형주 위주의 러셀 2000 지수는 1.06% 오른 2343.76을 기록했다.
        
        국내증시는 전일에 이어 외국인 매도세가 이어지면서 2거래일쨰 하락할 것으로 보인다. 전일 코스피 지수는 전장 대비 4.29포인트 내린 3247.83에 장을 마감했다. 외국인은 2거래일 연속 매도해 3900억원 규모를 팔았다. 
        
        민경원 우리은행 연구원은 “글로벌 달러화 반등, 국내증시의 외국인 투자심리 부진 등으로 1120원 탈환을 시도하겠지만 중공업 수주, 반기말을 앞둔 이월 수출 네고 등 수급부담 확대로 1110원 후반대에서 등락할 전망”이라고 말했다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/011/2021/06/11/0003921996_001_20210611052201638.jpeg",
        title: "인플레 공포는 없었다···S&P 사상 최고치 [데일리 국제금융시장]",
        date: '2021.06.04',
        description: `0.47% 상승한 4,239.18에 마감
        다우·나스닥도 각각 0.055%·0.78% 올라
        신규 실업급여 37.6만 건으로 최저치
        
        뉴욕증권거래소(NYSE) 내부. /AFP연합뉴스
        
        [서울경제] 
        
        5월 소비자물가지수(CPI)가 전년 대비 5%나 폭등한 것으로 나왔지만 시장의 우려는 적었다. 스탠더드앤드푸어스(S&P)500이 사상 최고치를 기록했다.
        
        10일(현지 시간) 미 경제 방송 CNBC에 따르면 이날 S&P500은 전날보다 19.63포인트(0.47%) 상승한 4,239.18에 거래를 마쳤다. 다우존스산업평균지수는 19.10포인트(0.055%) 오른 3만4,466.24, 나스닥은 108.58포인트(0.78%) 뛴 1만4,020.33에 마감했다. S&P500은 이날 사상 최고치를 경신했다.
        
        이날 나온 5월 CPI 상승폭은 2008년 여름 이후 가장 높았다. 최근까지 인플레이션 공포가 증시에 부담을 줘왔지만 막상 5월 CPI가 나오자 시장은 반대로 움직였다. 10년 만기 미 국채금리도 한때 연 1.530%를 넘어섰지만 다시 하락세로 돌아서 1.448%까지 내려왔다. 바이탈 날리지의 창업자 아담 크리사풀리는 “이 CPI가 상황을 극적으로 바꿀 것 같지는 않다”며 “여전히 인플레이션이 몇 달 안에 약해질 것이라는 징후가 있다”고 전했다.
        
        실업 급여청구 건수 감소는 투자심리에 도움을 줬다. 지난 주 신규 실업급여 청구건수는 37만6,000건으로 시장 예상치(37만건)를 밑돌았다. 코로나19 팬데믹 이후 최저치다.
        
        국제유가는 하반기 원유 수요가 유지될 것이라는 기대에 상승했다. 이날 뉴욕상업거래소의 7월물 서부 텍사스산 원유(WTI) 가격은 전날보다 33센트(0.5%) 오른 배럴당 70.29달러에 거래를 마쳤다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/366/2021/06/04/0000728286_002_20210604180406185.jpg",
        title: "비트코인 3만9,000달러대 회복···나스닥 1.41%↑···[데일리 국제금융시장]",
        date: null,
        description: `고용 시장 회복·연준 회사채 매각 영향
        외국인, 삼성전자 5일 연속 순매수
        
        
        4일 코스피지수가 기관의 매도세에 밀려 소폭 하락 마감했다. 전날에는 0.7% 넘게 오르며 사상 최고치인 3266.23에 근접하기도 했으나, 하루 만에 반락하며 최고점 경신에 실패했다.
        
        
        4일 오후 서울 중구 하나은행 본점 딜링룸에서 딜러들이 업무를 보고 있다.
        
        이날 코스피지수는 전날보다 7.35포인트(0.23%) 내린 3240.08로 마감했다. 기관 투자자들은 유가증권시장에서 총 6588억원을 순매도했다. 특히 금융투자 업계에서 6131억원어치를 팔았다. 반면 개인과 외국인은 각각 4709억원, 1616억원을 순매수한 것으로 집계됐다.
        
        기관 투자자들은 삼성전자(005930)와 LG화학(051910), NAVER(035420) 등의 대형주를 많이 매도했다. 특히 삼성전자 주식을 2061억원 순매도했으며, LG화학과 NAVER는 각각 636억원, 429억원어치 팔았다.
        
        외국인들은 지난 2일부터 3거래일 연속 순매수를 지속하고 있다. 이날 외국인 투자자들은 유가증권시장에서 기아(000270)와 현대차(005380), 현대모비스(012330) 등의 자동차주와 삼성전자(005930), SK하이닉스(000660) 등의 대형 반도체주를 많이 매수했다. 외국인 투자자들은 특히 삼성전자 주식을 5거래일 연속 순매수하고 있다. 지난 달 31일부터 5거래일 동안 외국인들이 사들인 삼성전자 주식은 총 8935억원어치다.
        
        이날 코스피지수의 하락은 전날 밤 미국 뉴욕 증시의 하락 마감에 영향을 받은 것으로 풀이된다. 3일(현지 시각) 뉴욕증권거래소(NYSE)에서 다우존스30산업평균지수는 전날보다 23.34포인트(0.07%) 내린 3만4577.04에 마감했다. 스탠더드앤드푸어스(S&P)500지수는 0.36%, 나스닥지수는 1.03% 하락 마감했다.
        
        한지영 키움증권 연구원은 “미 연방준비제도(Fed·연준)의 회사채와 채권 ETF 매각 발표, 5월 고용 지표 서프라이즈로 인한 시장 금리 상승, 미 달러화의 강세가 증시 하락 요인으로 작용했다”고 설명했다.
        
        
        3일(현지 시각) 미국 뉴욕 증권거래소의 입회장에서 트레이더들이 업무를 처리하고 있다. 뉴욕증시는 민간 고용 지표 등 주요 경제 지표가 긍정적으로 나왔지만, 긴축 우려가 커지면서 하락했다.
        
        민간고용정보업체 ADP 전미고용보고서에 따르면, 지난달 민간 부문 신규 고용은 총 97만7000건으로 전월(74만2000건)과 전망치(65만건)를 크게 웃돌았다. 또 연준은 지난해 3월 코로나19의 유행에 대응하기 위해 매입했던 회사채와 채권 ETF를 연말까지 매각하기로 결정했다. 한 연구원은 “인플레이션의 급등과 조기 테이퍼링(양적완화 축소) 우려가 해소되지 못한 상황에서, 시장 참여자들은 연준의 이 같은 정책 변화에 민감하게 반응했다”고 설명했다.
        
        이경민 대신증권 연구원은 다만 “고용 시장은 여전히 충분히 회복되지 못한 상황이기 때문에, 연준이 조기 테이퍼링에 나설 가능성은 크지 않다”며 “증시의 단기 변동성이 커질 수는 있으나, 6월 미 연방공개시장위원회(FOMC)에서 연준이 통화 완화 정책 기조를 유지할 지 재확인하며 관망할 필요가 있다”고 설명했다.
        
        한편, 이날 코스닥지수는 외국인과 기관의 동반 매도세에 밀려 소폭 하락 마감했다. 전날보다 2.61포인트(0.26%) 내린 987.58을 기록했다.
        
        외국인과 기관은 각각 918억원, 696억원을 순매도한 것으로 집계됐다. 반면 개인은 1918억원을 순매수했다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/015/2021/05/21/0004549605_001_20210521071201612.jpg",
        title: "이스라엘-하마스, 열흘만에 휴전…뉴욕증시, 상승 마감 [모닝브리핑]",
        date: '2021.05.21',
        description: `◆ 이스라엘-하마스, 충돌 열흘 만에 조건 없이 휴전

        이스라엘과 팔레스타인 무장조직 하마스가 대규모 유혈 충돌을 일단락짓기로 합의했습니다. 현지시간 20일 로이터통신 등 외신에 따르면 이스라엘 정부와 하마스는 21일 오전 2시를 기해 휴전에 들어가기로 했습니다. 이스라엘정부는 20일 안보관계 장관 회의를 열고 휴전안을 승인했습니다. 이달 10일 하마스의 선제 공격에 무자비한 폭격으로 대응한지 열흘 만입니다.
        
        ◆ 뉴욕증시, 주간 실업 지표 개선에 상승 
        
        뉴욕증시 주요 지수가 미국 실업 지표 개선에 힘입어 상승했습니다. 현지시간 20일 뉴욕증권거래소(NYSE)에서 다우존스 30 산업평균지수는 전 거래일보다 188.11포인트(0.55%) 오른 34,084.15를 기록했습니다. 스탠더드앤드푸어스(S&P) 500 지수는 43.44포인트(1.06%) 상승한 4,159.12로 장을 마감했습니다. 기술주 중심의 나스닥 지수는 236.00포인트(1.77%) 뛴 13,535.74로 장을 마쳤습니다. 이날 발표된 주간 실업보험 청구자 수가 신종 코로나바이러스 감염증(코로나19)의 세계적 대유행(팬데믹) 이후 최저치를 경신, 고용 시장이 개선되고 있음을 시사했습니다.
        
        ◆ 국제유가, 이란 핵합의 복원 기대에 하락
        
        국제유가는 하락했습니다. 이란 핵합의(JCPOA·포괄적 공동행동계획) 복원 회담에서 진전이 있었다는 소식에 투자심리가 약화된 결과입니다. 뉴욕상업거래소에서 6월물 서부텍사스산원유(WTI) 가격은 전 거래일보다 1.31달러(2.1%) 내린 배럴당 62.05달러를 기록했습니다. WTI 6월물은 이날이 만기일입니다. 팩트셋에 따르면 이날 종가는 4월 26일 이후 최저치를 기록했습니다.
        
        ◆ 백악관 "한·미정상회담서 북한도 중심 주제"
        
        미국 백악관은 현지시간 21일 개최되는 한·미 정상회담에서 북한이 핵심 의제 가운데 하나가 될 것이라고 밝혔습니다. 젠 사키 백악관 대변인은 브리핑에서 정상회담 의제와 관련해 "우리는 물론 북한이 내일 논의의 중심 주제가 될 것으로 예상한다"고 말했습니다. 또한 기후, 경제적 동반자 관계도 논의할 것이라고 전했습니다. 그는 "또한 중국에 대해 논의할 것"이라며 "그것들은 모두 내일 양자 대화와 회담의 일부가 될 것"이라고 언급했습니다.
        
        ◆ 펠로시 만난 문대통령 "한반도 평화·코로나 극복 계기"
        
        미국을 공식방문 중인 문재인 대통령은 20일 미국 하원 지도부를 만나 코로나19 극복을 위한 한·미 협력의 중요성을 강조했습니다. 문 대통령은 낸시 펠로시 미 하원 의장과 함께한 간이 연설에서 "코로나는 사람 간 물리적 거리를 넓혔지만, 역설적으로 전 인류가 하나로 연결됐음을 증명했다"고 말했다. 이어 "70년간 다진 한·미 동맹이 (연대와 협력의) 모범이 될 것"이라며 "의원님들과의 만남으로 시작될 한·미 대화가 한반도 평화는 물론 코로나 극복, 경제회복, 기후변화 대응 등 양국 협력을 더 깊게 하고 전 세계의 연대를 이끄는 계기가 되기를 기대한다"고 밝혔습니다.
        
        지금까지 한경닷컴 오정민 기자였습니다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/421/2021/06/14/0005413919_002_20210614165608702.jpg",
        title: "[시황종합] 코스피 3252.13 사상 최고…카카오, 네이버 시총 육박",
        date: '2021.06.14',
        description: `FOMC 앞두고 관망세 속 코스피 0.09% 오른 3252.13
        코스닥 0.63% 오른 997.41…달러/원 환율 5.9원 오른 1116.7원
        
        
        (서울=뉴스1) 박응진 기자 = 14일 코스피 지수는 개인 순매수에 힘입어 종가 기준 사상 최고치인 3252.13으로 마감했다. 대표적인 성장주인 카카오와 NAVER는 나란히 상승세를 나타내며 시가총액 3위 쟁탈전을 벌였다. 코스닥 지수도 상승했다. 
        
        다만 오는 15~16일 열릴 미국 연방공개시장위원회(FOMC)의 인플레이션(물가 상승) 진단과 테이퍼링(양적완화 점진적 축소) 논의 여부를 확인하기 위한 관망세가 강한 편이었다. 
        
        이날 코스피는 전 거래일(11일) 종가와 비교해 2.81포인트(p)(0.09%) 오른 3252.13으로 마감했다. 3거래일 연속 상승 마감으로, 지난 7일 코스피 사상 최고치(3252.12)보다 0.01p 높은 수준이다. 
        
        개인이 홀로 3546억원 순매수했고, 기관과 외국인이 각각 3333억원, 243억원 순매도했다. 개인은 순매수로 돌아섰고, 기관과 외국인은 순매도로 전환했다. 
        
        코스피 시가총액 상위 10개 종목 가운데 셀트리온(5.84%), 카카오(5.17%), NAVER(3.89%), 삼성바이오로직스(0.95%), 삼성SDI(0.16%)는 올랐고, LG화학(-2.71%), SK하이닉스(-0.78%), 삼성전자(-0.62%), 현대차(-0.21%), 삼성전자우(-0.13%)는 떨어졌다. 
        
        카카오와 네이버는 동반 상승세를 나타내며 코스피 시가총액 3위 자리를 놓고 경쟁했다. 5거래일 연속 신고가를 기록한 카카오의 시가총액(63조2599억원)은 NAVER(63조5699억원)에 바짝 근접했다.
        
        업종별로는 종이·목재(3.02%), 서비스업(2.21%), 의약품(1.95%) 등이 상승했고, 증권(-0.96%), 금융업(-0.82%), 보험(-0.66%) 등이 하락했다. 종이·목재의 강세는 국제 펄프 가격 상승에 따른 제지주 수혜 예상에 따른 것으로 보인다. 
        
        코스닥은 전 거래일보다 6.28p(0.63%) 오른 997.41로 마감했다. 3거래일 연속 상승 마감이다. 기관과 개인이 각각 225억원, 123억원 순매수했고 외국인이 홀로 320억원 순매도했다. 
        
        코스닥 시가총액 상위 10개 종목 중에서는 CJ ENM(-1.49%)을 제외한 모든 종목이 올랐다. 상승률은 셀트리온제약(12.82%), 셀트리온헬스케어(4.93%), 씨젠(5.45%), 펄어비스(3.72%), 알테오젠(3.32%), 카카오게임즈(2.12%), 에코프로비엠(0.05%), SK머티리얼즈(0.32%), 에이치엘비(0.30%) 순으로 높았다.
        
        셀트리온 3형제는 코로나19 항체 치료제 렉키로나가 임상 3상에서 효능과 안전성이 입증됐다는 소식에 동반 상승세를 나타냈다.
        
        기업회생절차를 밟고 있는 이스타항공의 인수전에 참여했던 하림이 본입찰을 포기한 것으로 전해지면서 장 막판 하림의 주가는 20.07% 급락했고, 입찰 경쟁자인 쌍방울은 17.71% 급등 마감했다.
        
        업종별로 보면 유통(3.19%), 제약(2.08%), 디지털콘텐츠(1.24%) 등이 올랐고, 금융(-0.97%), 섬유·의류(-0.89%), 음식료·담배(-0.73%) 등은 내렸다. 
        
        서울외환시장에서 달러/원 환율은 전 거래일 대비 5.9원 오른 1116.7원으로 거래를 마쳤다. 
        
        이경민 대신증권 투자전략팀장은 "코스피는 외국인 현선물 순매도 속에 3250선에서 제한적 등락을 반복했다"며 "개인 현선물 순매수세가 증시 하단을 지지한 가운데 FOMC 회의를 앞두고 관밍심리가 유입됐다"고 분석했다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/06/14/0004957415_001_20210614154802599.jpg",
        title: "[외환마감]환율, 2거래일만에 1110원 중반 회복..'달러 강세 지속'",
        date: null,
        description: `美연준 FOMC 앞두고 강달러..국채 금리 1.4% 중반 등락
        뉴욕지수선물 상승, 코스피 신고점..위험선호 심리도 유지
        
        사진=AFP
        [이데일리 이윤화 기자] 원·달러 환율이 6원 가량 올라 2거래일만에 1110원대 중반을 회복했다. 연방준비제도(Fed·연준)가 15~16일 예정된 연준 연방공개시장위원회(FOMC) 정례회의를 앞둔 가운데 미 국채 금리가 1.4% 중반대로 소폭 올랐고, 달러화도 반등한 영향이다. 유럽중앙은행(ECB)의 온건한 통화정책 유지 등 유로화 약세도 달러 강세에 일조했다. 
        
        
        14일 서울외국환중개에 따르면 원·달러 환율은 전 거래일(1110.8원) 보다 5.9원 오른 1116.7원에 거래를 마쳤다. 이날 환율은 전 거래일 대비 5.5원 오른 1116.3원에 출발한 뒤 1110원 중반대에서 등락했다. 장중 한때 1118.10원까지 오르면서 상승폭을 키웠지만 코스피가 사상 최고치 수준으로 오르면서 환율 오름폭은 제한됐다. 
        
        미 국채 금리는 여전히 1.4%대에서 움직이고 있지만 지난주 보다는 반등했다. 시장에서는 장기적인 인플레이션(물가상승) 가능성은 낮고, 연준의 완화적 통화정책 기조도 당분간 유지될 것이란 기대가 더 크지만 오는 15~16일 진행될 를 앞두고 지난주 1.4% 초반에서 중반대로 올라 등락하는 중이다. 
        
        14일 오전 2시반께 10년물 국채 금리는 전일 대비 0.005%포인트 하락한 1.457%를 기록하고 있다. 달러인덱스도 90포인트 중반대로 올랐다. 뉴욕증시 증시 종가 수준보다 0.056%포인트 오른 90.573을 기록하고 있다. 
        
        뉴욕지수 선물 뉴욕증시 상승 마감 등 위험선호 분위기를 이어받아 오름세를 보이고 있다. 다우지수 선물은 전 거래일 대비 0.03% 오른 3만4473을 기록하고 있다. 스탠더드 앤드 푸어스(S&P)500지수 선물도 0.06% 오른 4248.25를 나타냈다. 나스닥 100 선물은 0.15% 뛴 1만4015.25에 거래되고 있다. 
        
        국내증시도 3거래일째 상승하면서 지난 7일 최고가 수준인 3252선까지 올랐다. 외국인이 234억원 가량 팔면서 나흘 만에 매도세로 돌아섰지만 지수 상승은 이어졌다. 코스피 지수는 이날 전 거래일 대비 2.81포인트(0.09%) 오른 3252.13에 장을 마감했다. 지난 7일 기록한 3252.12 수준이다. 
        
        이날 서울외국환중개와 한국자금중개에서 거래된 합산 금액은 52억700만달러로 집계됐다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/277/2021/06/14/0004919440_001_20210614075905190.jpg",
        title: "[굿모닝 증시] 테이퍼링을 두려워하지 말라?",
        data: '2021.06.14',
        description: `하이투자증권 "이번 테이퍼링 신호가 2013년 긴축발작 수준으로 이어지진 않을 것" 유안타증권 "금리 하락은 경기 회복에 대한 비관적 시각을 포함한 현상일 수도" [이미지출처=AP연합뉴스] [아시아경제 공병선 기자] 미국 연방준비제도(Fed)의 자산매입축소(테이퍼링) 충격이 예상보다 크지 않을 것이란 전망이 나온다. 중국의 경제 상황이 과거와 달라졌다는 이유에서다. 하지만 예상치를 상회하는 인플레이션 속에서 금리가 하락하는 상황을 긍정적으로 받아들이긴 어렵다는 관측도 제시됐다. 지난 11일(현지시간) 다우존스30산업평균지수는 전 거래일 대비 0.04%(13.36포인트) 상승한 3만4479.60으로 장을 마쳤다. S&P500지수는 전장보다 0.19%(8.26포인트) 상승한 4247.44로 장을 마감했다. 기술주 중심의 나스닥 지수는 전 거래일 대비 0.35%(49.09포인트) 오른 1만4069.42를 기록했다. ◆박상현 하이투자증권 연구원=미 Fed의 테이퍼링 신호는 이제 시간만 남았다. 인플레이션과 고용시장 상황에 따라 Fed가 금융시장에 언제 테이퍼링 신호를 줄지 유동적이지만 미국 경기 사이클과 각종 자산가격 상승폭을 고려할 때 테이퍼링 신호는 연내 가시화될 여지가 높다. 이에 2013년 테이퍼링 발표로 촉발된 긴축발작 현상이 이번에도 재현될지 관심사다. 하지만 이번 테이퍼링 신호는 2013년과 같은 긴축발작 수준은 아닐 것으로 예상된다. 당시와 비교해 현재는 글로벌 경기 사이클, 중국 경기 리스크, 달러화 흐름, 글로벌 교역 사이클, 신용리스크 측면에서 차별성을 보이고 있기 때문이다. 특히 2013년엔 중국 등 이머징 금융시장이 큰 충격을 받았지만 중국 경제 상황과 정책은 과거와 많은 차이점을 보이고 있다. 이에 테이퍼링 충격을 완화시키는 역할을 할 것으로 예상된다. 단순한 테이퍼링 리스크 충격보단 부도 리스크를 촉발시킬 수 있는 잠재적 리스크에 주목해야 한다. 주식시장 등 자산가격의 추세적 하락은 신용리스크, 즉 부도리스크가 부각될 경우 발생할 수 있다. 현 시점에선 뚜렷한 신용리스크가 가시화되지 않고 있지만 잠재적 신용리스크로 혁신기술 사이클에 대한 부정적 시각 확산, 미중 갈등 본격화 등이 있다. (제공=유안타증권) ◆조병현 유안타증권 연구원=방어적 관점을 생각해볼 때다. 지난주 발표된 미국의 물가 지표가 다시 한 번 예상치를 상회했다. 지난달 미국 소비자물가지수(CPI)는 전년 대비 5% 상승하면서 시장전망치 4.7%보다 높았다. 기저효과에 더해 중고차 가격의 상승 영향 등 다양한 원인이 가파른 물가 상승의 원인으로 지목된다. 하지만 이 같은 물가 상승에도 불구하고 금융시장의 반응은 이례적이다. 특히 미 국채 금리의 경우 인플레이션 급등 속에서 하락폭을 키우며 1.4%대에 진입했다. 일반적으로 증시 투자자 입장에선 금리 상승 쪽에만 경계심을 키우는 경우가 많다. 하지만 금리의 상승이 인플레이션과 경기 회복 기대감을 반영한다는 측면을 보면 반대 현상인 금리 하락은 경기 회복에 대한 비관적 시각을 포함하는 현상일 수 있다. 경기 회복보다 통화정책에 대한 기대감이 금리 하락을 이끄는 상황이라면 다르게 해석할 여지가 있다. 하지만 현 시점에서 개선되고 있던 경기 회복에 대한 기대감이 후퇴한다는 것으로 해석한다면 긍정적으로 받아들이기 어려운 상황이다. 지난 2017~2018년 당시 금리 상승이 증시의 변동성을 키운 것은 사실이지만 금리와 기대 인플레이션이 함께 하락하는 상황에서도 변동성이 커졌다는 점을 생각해볼 필요가 있다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/008/2021/06/11/0004600386_001_20210611080901390.jpg",
        title: "강해진 인플레 압력…테이퍼링 가능성 점차 커진다",
        data: '2021.06.11',
        description: `미국의 인플레이션 압력이 점차 커지고 있다. 에너지, 식료품 가격 뿐만 아니라 중고차, 의류, 대중교통비, 항공료 등 전반적인 소비자물가가 가파른 오름세다.

        원자재 가격상승이 제품가격으로 전가될 개연성도 높은 가운데 재정건전성이 취약한 신흥국들은 자본유출을 억제하기 위해 긴축적인 통화정책으로 선회 중이다.
        
        심지어 수요를 따라가지 못한 공급망 병목현상이 지속되면서 원자재 가격의 추가모멘텀으로 작동한다. 전문가들은 물가압력이 전방위적으로 커지는 가운데 미국 연준(Fed)이 조만간 테이퍼링 논의를 공식화할 가능성이 커지고 있다고 전망한다.
        ◇美 소비자물가 상승률, 13년만에 최고
        
        FILE - In this Monday, Sept. 21, 2020, file photo, a Wall Street street sign is framed by a giant American flag hanging on the New York Stock Exchange in New York. Stocks are falling in early trading on Wall Street Monday, Oct. 26, 2020, and deepening last week’s losses. (AP Photo/Mary Altaffer, File)
        
        5월 미국 소비자물가는 2008년 8월 이후 13년 만에 가장 빠른 속도로 상승했다. 특히 치솟는 중고차 가격이 상승의 대부분을 견인했다.
        
        이날 미 노동부에 따르면, 5월 소비자 물가는 전달 대비 0.6% 상승했다. 이는 다우존스와 월스트리트저널이 조사한 시장 전망치(0.5%)를 상회한 수치다. 5월 전체 상승분의 3분의 1을 중고차 가격 폭등이 차지했다.
        
        핵심 소비자물가 상승률 또한 전년 대비 3.8%로 발표돼 예상치(3.4%)를 상회했고 연준의 목표치인 2.0%도 초과했다. 1992년 6월 이후 가장 큰 상승세다. 품목별로는 중고차가 전월 대비 7.3% 급등했고 △대중교통비(4.0%↑) △항공료(7.0%↑) △의류(1.2%↑) △주거비용(0.3%↑) 등이 올랐다. 
        
        이날 미국 증시는 장 초반 소비자물가가 일시적인 상승일 뿐이란 분석에 상승폭을 키웠지만 여전히 인플레 압력 확산에 대한 우려로 매물이 출회돼 상승분을 대부분 반납했다.
        
        서상영 미래에셋증권 연구원은 "그럼에도 불구하고 시장이 물가상승은 일시적이라고 합의하는 과정을 보여준 점은 투자심리에 긍정적이다. 이는 FOMC(연방공개시장위원회)에 대한 우려가 완화될 수 있기 때문"이라며 "특히 ECB 통화정책회의에서 성장률 상향조정을 발표했음에도 긴축논의는 시기상조라고 언급하는 등 비둘기적 성향을 보인 것처럼 FOMC도 비슷한 변화를 보일 것으로 기대한다"고 말했다.
        
        그러면서 "이를 감안해 한국 증시는 0.5% 내외 상승 출발 후 반도체, 제약 등 미 증시 상승을 주도한 업종이 강세를 보이며 상승세를 유지할 것으로 전망한다"고 밝혔다.
        ◇테이퍼링 공식화 가능성↑
        
        제롬 파월
        
        물론 지금의 상승세는 코로나19로 인한 기저효과라는 분석이 많은 만큼 상승폭이 점차 완만해질 가능성이 높다. 다만 공급망 차질이 이어지고 임금도 상승하면서 물가하단이 지지될 전망이다.
        
        전규연 하나금융투자 연구원은 "수요는 급증하는데 방역 문제로 항구와 터미널을 통한 이동이 제한되며 공급측 병목현상이 나타나고 있다"며 "최근 미국의 재고율 하락으로 주택가격이 가파른 상승흐름을 이어가고 있어 관련 물가압력도 유효하다"고 설명했다. 주택가격은 임대료 가격상승으로 전가되며 소비자물가에 영향을 미칠 개연성이 높다는 것이다.
        
        그러면서 "예상보다 강한 물가압력이 지속되고 고용시장이 회복되면서 미 연준이 테이퍼링 논의를 공식화할 가능성이 점차 커지고 있는 시점"이라고 덧붙였다.
        
        연준이 다음주 15~16일(현지시간) 예정된 FOMC 회의에서 테이퍼링 논의에 나설 수 있다고 밝힐 것이란 분석도 나온다.
        
        임혜윤 ktb투자증권 연구원은 "파월 연준 의장은 '좋은' 고용지표를 확인한 후 테이퍼링 논의를 시작한다고 밝힐 것으로 보인다"며 이 고용지표는 하반기에 충분히 확인이 가능하다고 말했다.
        
        임 연구원은 제조업과 서비스업 구인수요는 모두 안정적으로 증가하고 있으며 추가 실업수당 지급이 종료(6~9월)되면 저임금 근로자들의 재취업 유인이 강화될 것이라고 내다봤다.
        
        그는 "연준이 앞으로 2~3개월 간 고용의 양적·질적 개선을 확인한 후 8월 잭슨홀 미팅 또는 9월 FOMC에서 테이퍼링 논의를 구체화하고 내년 상반기 테이퍼링에 나설 것이라고 본다"고 전망했다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/008/2021/06/12/0004600813_001_20210612065101397.jpg",
        title: `"인플레는 일시적"...S&P 이틀째 '최고치' 행진[뉴욕마감]`,
        date: '2021.06.12',
        description: `[머니투데이 뉴욕=임동욱 특파원] 대형주 중심의 스탠다드앤푸어스(S&P)500 지수가 이틀 연속 종가 기준 사상 최고치 경신 행진을 했다. AMC 등 '밈(meme)' 종목들은 이날 반등했다. 

        S&P500 이틀연속 '사상최고치' 경신
        
        
        
        월가_황소상
        
        11일(현지시간) 뉴욕증시에서 대형주 중심의 S&P500지수는 전날보다 8.26포인트(0.19%) 오른 4247.44를 기록하며 이틀 연속 사상 최고치를 경신 했다. .
        
        블루칩(우량주) 클럽인 다우존스산업평균지수는 전 거래일보다 13.36포인트(0.04%) 오른 3만4479.60으로 마감했다. 
        
        기술주 중심의 나스닥 종합지수는 49.09포인트(0.35%) 오른 1만4069.42로 거래를 마쳤다. 
        "인플레 압력...일시적인게 맞다"
        
        
        The Fearless Girl statue is seen outside the New York Stock Exchange (NYSE) in Election Day in Manhattan, New York City, New York, U.S., November 3, 2020. REUTERS/Andrew Kelly
        
        이날 뉴욕증시는 전날 나온 소비자 물가 관련 데이터를 시장이 무시하는 모습을 보이면서 강세를 보였다. 
        
        파이퍼 샌들러의 크레이그 존슨 시장전략가는 CNBC에 "5월 CPI(소비자물가지수) 보고서가 예상치를 웃도는 수준이었지만, 시장은 그다지 놀라지 않았고 이 수치를 '과도기적인' 것으로 소화해 냈다"고 진단했다. 
        
        이어 "채권 시장은 인플레이션이 일시적일 것이라는 전망에 동의하는 것 처럼 보인다"고 덧붙였다. 
        
        이날 1.441%로 출발한 미국 10년 만기 국채수익률은 장중 1.428%까지 떨어지며 3개월래 최저치까지 추락했다가 오후 들어 1.453% 수준으로 반등했다. 올들어 인플레 위협이 높아지면서 10년물 금리는 1.77%까지 치솟은 바 있다. 
        
        기술주 강세, '밈' 종목들은 반등
        
        AMC
        
        기술주들은 강세를 보였다. 엔비디아와 애플은 이날 각각 2.29%, 0.98% 상승 마감했다. 마이크로소프트, 넷플릭스 주가는 이날 각각 0.25%, 0.30% 올랐다. 줌 비디오와 펠로톤은 각각 5.74%, 6.63% 상승했다. 
        
        전날 급락했던 '밈' 종목들은 이날 반등세를 보였다. AMC는 이날 15.39% 올랐고, 게임스톱은 5.88% 상승했다. 
        
        피터 베레진 BCA리서치 투자전략가는 "밈 주식의 부침은 일반적으로 주식 시장의 전반적인 방향에 거의 영향을 미치지 않는다"며 "그러나 밈 주식에 대한 관심이 높아지는 것은 중기적으로 볼 때 주식에 긍정적"이라고 밝혔다. 밈 종목들이 주식시장에 자금을 끌어들이는 과정에서 주식가격과 유동성을 함께 견인하고 있기 때문이란 설명.
        
        FDA "오염가능성 J&J백신 6000만회분 폐기"
        
        얀센백신
        
        미국 식품의약국(FDA)이 제조 과정에서 오염 가능성이 있는 존슨앤존슨(J&J, 얀센)의 코로나19(COVID-19) 백신 6000만회 분에 대해 사용불가를 통보했다. 
        
        이날 뉴욕타임스에 따르면, 이날 FDA는 존슨앤존슨에 문제가 된 발티모어 공장에서 생산된 백신을 폐기해야 한다고 말했다. 뉴욕타임스는 이번 조치로 폐기될 백신이 약 6000만회 분에 달할 것이라고 보도했다. 
        
        FDA는 1000만회분은 백신 제조사인 이머전트 바이오솔루션즈가 모범적인 제조 관행을 따랐다는 것을 보장하지 않는다는 경고문을 붙여 미국과 해외 국가들로 보낼 계획이다. 
        
        지금까지 미국 내에서 사용된 존슨앤존슨 백신은 이머전트가 아닌 네덜란드 공장에서 제조됐다. 이머전트는 지난 3월 볼티모어 공장에서 아스트라제네카와 존슨앤존슨 백신의 핵심 성분이 서로 섞인 것을 발견했고, FDA는 이곳에서 생산된 약 1억7000만개의 백신의 사용을 보류하고 처리 방안에 대해 조사해 왔다. 이번 명령은 보류된 백신에 대한 결정이다. 
        
        뉴욕증시에서 이날 존슨앤존슨 주가는 1.27% 하락했다. 
        
        
        [골드스미스=AP/뉴시스]21일(현지시간) 미 텍사스주 골드스미스 인근 유정의 원유시추기 펌프잭 뒤로 해가 지고 있다. 2021.04.22.
        
        유가는 올랐다.
        
        뉴욕상업거래소(NYMEX)에서 WTI(서부 텍사스산 원유) 7월 인도분은 배럴당 0.49달러(0.70%) 오른 70.78달러에 거래를 마쳤다. 
        
        런던 ICE 선물거래소에서 오후 10시38분 기준 국제유가의 기준물인 8월분 북해산 브렌트유는 배럴당 0.13달러(0.18%) 오른 72.65달러를 기록 중이다.
        
        금 가격은 내렸다. 이날 뉴욕상품거래소에서 8월 인도분 금 가격은 전 거래일보다 온스당 16.90달러(0.89%) 내린 1879.50달러에 거래를 마쳤다. 
        
        달러화는 강세다. 이날 뉴욕외환시장에서 달러인덱스(DXY)는 전날보다 0.48% 오른 90.51을 기록했다. 달러인덱스는 유로, 엔 등 주요 6개 통화를 달러화 가치를 지수화한 것이다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/011/2021/06/08/0003920334_001_20210608092902480.jpg",
        title: "[오전시황] 보합세 출발한 코스피, 3,250선 등락 거듭···美 증시 혼조세 영향",
        date: '2021.06.08',
        description: `코스닥, 하락세 전환···980선 거래


        [서울경제] 
        
        전일 사상 최고치를 기록했던 코스피가 8일 보합세로 출발했다. 전날 개인의 순매수에 힘입어 코스피 지수는 장 중 3,260선을 넘어섰지만, 이날은 3,250선에서 등락을 거듭하고 있다. 
        
        이날 오전 9시 20분 코스피는 전 거래일보다 1.12포인트(0.03%) 내린 3,251.00을 가리켰다. 이날 코스피는 0.29포인트(0.01%) 내린 3,251.83에 거래를 시작했다. 
        
        세부 주체별로는 개인과 외국인이 각각 184억원, 1710억원어치를 매도하며 지수를 끌어 내리고 있다. 반면 기관은 2,009억원어치를 순매수했다.
        
        전일 미국 증시는 지수 레벨 부담 등에 따라 혼조세로 장을 끝냈다. 오는 10일 발표될 5월 소비자물가지수(CPI)에 이어 재닛 옐런 미 재무장관이 테이퍼링(유동성 공급 축소)와 금리 인상을 검토할 수 있다는 취지의 발언을 한 것이 부담으로 작용했다. 다우 지수는 전장 대비 126.15포인트(0.36%) 내린 3만4,630.24로, S&P500 지수는 3.37포인트(0.08%) 하락한 4,192.85로 거래를 마쳤다. 반면 기술주 중심의 나스닥 지수는 67.23포인트(0.49%) 오른 1만3,881.72로 장을 마감했다.
        
        시가총액 상위 종목들도 혼조세를 보이고 있다. 삼성전자(005930)는 전일 대비 0.12%(100원) 오른 8만2,000원에 거래되고 있고, 네이버(0.28%), 삼성바이오로직스(207940)(3.09%), 카카오(035720)(0.79%), 셀트리온(0.95%) 등도 상승세다. 반면 SK하이닉스(000660)(-2.72%), LG화학(-0.74%), 현대차(-1.24%) 등은 하락하고 있다. 
        
        같은 시간 코스닥지수는 전장보다 2.05포인트(0.21%) 내린 983.81을 가리켰다. 이날 코스닥 지수는 0.57포인트(0.06%) 오른 986.43에 출발했다. 
        `,
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/06/07/0004949897_001_20210607081703541.jpg",
        title: "[외환브리핑]美고용지표 실망에 금리 반락..환율, 1110원 초반 하락 전망",
        date: '2021.06.07',
        description: `5월 미국 고용지표, 4월 이어 두달째 시장예상치 하회
        미 국채 금리 10년물 1.5% 중반, 달러화 지수도 반락
        [이데일리 이윤화 기자] 재닛 옐런 미국 재무부 장관이 또다시 금리 인상을 용인하는 발언을 했지만 시장은 예상보다 부진했던 미국 고용지표에 더 주목했다. 지난 주 연 1.6%대까지 올랐던 미국 국채 10년물 금리는 다시 1.5% 중반대까지 하락했고 달러화 지수도 반락했다. 통화 긴축 우려가 진정되자 기술주를 중심으로 뉴욕증시가 일제히 오르며 투자심리는 살아났다. 이에 원·달러 환율은 국채 금리 하락에 따른 달러 약세에 나흘 만에 1110원대 초반으로 하락할 전망이다. 
        
        
        뉴욕증권거래소. (사진=연합뉴스)
        7일 서울외국환중개에 따르면 간밤 뉴욕차액결제선물환(NDF) 시장에서 거래된 원·달러 1개월물은 1110.6원에 최종 호가됐다. 최근 1개월물 스와프포인트(-0.05원)를 고려하면 이날 환율은 전 거래일 종가(1116.50원)보다 5.85원 가량 하락 출발할 것으로 보인다. 
        
        미국의 지난달 고용지표는 4월에 이어 부진했다. 미 노동부에 따르면 5월 비농업 신규 고용은 55만9000명 증가했다. 27만8000명 증가한 4월 고용 지표에 비하면 2배 가량 늘었지만, 여전히 다우존스가 집계한 시장 예상치(67만1000명)를 한참 밑도는 수치다. 2개월 연속 시장예상치를 하회한 것이다. 
        
        10년물 금리는 1.5%대, 달러인덱스는 90포인트대 초반에서 움직이고 있다. 6일(현지시간) 오후 7시께 10년물 국채 금리는 전일 대비 0.003%포인트 내린 1.557%를 기록하고 있다. 달러인덱스는 뉴욕증시 종가 수준보다 0.001%포인트 오른 90.158를 기록하고 있다. 
        
        미국 연방준비제도(Fed·연준)의 통화 긴축 우려가 잠잠해지면서 시장은 다시 위험선호 심리를 키웠다. 지난 4일(현지시간) 마켓포인트에 따르면 이날 미국 뉴욕증권거래소에서 다우존스 30 산업평균지수는 전거래일 대비 0.52% 오른 3만4756.39에 거래를 마쳤다. 스탠더드앤드푸어스(S&P) 500 지수는 0.88% 상승한 4229.89에 마감했다. 나스닥 지수는 1.47% 뛴 1만3814.49를 나타냈고, 중소형주 위주의 러셀 2000 지수도 0.31% 오른 2286.41을 기록했다.
        
        옐런 장관은 또 다시 금리 인상에 대한 가능성을 내비쳤지만 인플레이션(물가 상승)에 대해서는 일시적이라는 입장을 고수했다. 6일(현지시간) 블룸버그와의 인터뷰에서 “우리가 다소 높은 금리 환경을 가지게 되더라도 연준을 포함한 우리 모두에게 긍정적”이라면서 “지난 10년간 저물가와 싸워온 만큼 정상적인 금리 환경으로 돌아사는 것이 나쁜 일이 아니다”라고 말했다. 
        
        역외시장에서 위안화 역시 달러 대비 강세를 보이고 있다. 달러·위안 환율은 전장 대비 0.01% 하락한 6.3906위안에 거래되고 있다. 달러·위안 환율 하락은 위안화 강세를 의미하며 동조현상이 강한 원화도 강세 압력을 높일 수 있다. 
        
        이에 국내 증시도 외국인 자금 유입이 이어지면서 1거래일 만에 상승할 수 있을지 주목된다. 지난주 마지막 거래일인 4일 코스피 지수는 외국인 자금 1754억원 순매수에도 7.35포인트 하락한 3240.08에 장을 마감했다. 
        
        박상현 하이투자증권 연구원은 “5월 고용지표로 조기 테이퍼링 리스크가 완화되면서 10년 국채 금리가 다시 1.5%대로 하락했다”면서 “6월 연방공개시장위원회(FOMC) 회의를 앞두고 있지만 글로벌 자금의 위험자산 선호 현상이 더욱 강화될 전망이다. 특히 중국 및 대만 등 중화권 증시가 동반 상승하고 있음을 고려할 때 외국인의 국내 주식 순매수 흐름도 이어질 공산이 높다”고 말했다.
`,
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/06/03/0004946790_001_20210603170802782.jpg",
        title: "[외환마감]中인민은행 위안화 절하 고시, 원화약세 동조에 환율 강보합",
        date: '2021.06.03',
        description: `中인민은행, 위안화 절하 고시..원화도 약세 동조
        미 국채 금리 1.5%, 달러인덱스 90포인트선 등락
        [이데일리 이윤화 기자] 원·달러 환율이 0.3원 올라 강보합 마감했다. 장 초반에는 4일(현지시간) 발표되는 미국 고용지표를 앞두고 시장이 관망세를 보였고, 최근 조선업의 대규모 수주 수식 등에 달러 약세 우위가 높았지만 오후들어 중국 인민은행이 위안화 절하를 고시하면서 원화도 이에 동조하며 약세 흐름을 보였다. 이에 원·달러 환율도 소폭 상승하며 2거래일쨰 올랐다. 
        
        
        사진=AFP
        3일 서울외국환중개에 따르면 원·달러 환율은 전 거래일(1113.3원) 보다 0.3원 상승한 1113.6원에 강보합 마감했다. 이날 환율은 전 거래일 대비 1.8원 하락한 1111.5원에 개장해 1110원 초반대에서 등락하다가 오후 들어 상승폭을 키웠다.
        
        
        이날 환율 상승 전환을 주도한 것은 중국 인민은행의 위안화 절하 고시였다. 인민은행은 이날 오전 달러·위안 거래 기준환율을 전장대비 0.0038위안(0.06%) 오른 6.3811위안에 고시했다. 달러·위안 환율 상승은 달러 대비 위안화의 가치 하락을 의미한다. 이에 동조한 원화도 동반 하락하는 모습을 보였다. 달러·위안 환율은 전 거래일 대비 0.10% 오른 6.39위안에 거래되고 있다. 
        
        미 국채 10년물 금리는 1.5%대 후반대로 소폭 하락했다. 미국 연방준비제도(Fed·연준)가 발표한 경기평가 자료 ‘베이지북’에서 나타난 경기 낙관 전망에도 연준이 당분간 완화적 통화 정책을 이어갈 것이라는 시장 기대 덕분이다. 달러인덱스는 90포인트선에서 등락하고 있다. 3일 오전 3시께 10년물 국채 금리는 전일 대비 0.005%포인트 내린 1.596%를 기록하고 있다. 달러인덱스는 뉴욕증시 증시 종가 수준보다 0.160%포인트 오른 90.075를 기록하고 있다.
        
        뉴욕지수 선물은 하락세를 보이고 있다. 다우지수 선물은 전 거래일 대비 0.08% 하락한 3만4563을 기록하고 있다. 스탠더드 앤드 푸어스(S&P) 500 지수 선물도 0.05% 내린 4204를 나타냈다. 나스닥 100 선물은 0.05% 떨어진 1만3667.5에 거래되고 있다. 
        
        국내증시는 외국인이 2거래일째 매수세를 보이면서 5거래일째 상승했다. 이날 코스피 지수는 전일 대비 23.20포인트(0.072%) 오른 3247.43에 장을 마쳤다. 외국인은 2375억원 가량 매수했다. 
        
        이날 서울외국환중개와 한국자금중개에서 거래된 자금은 82억7400만달러다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/003/2021/06/01/NISI20210601_0017512625_web_20210601155739_20210601163407507.jpg",
        title: "[마감시황]코스피, 최고가 눈앞…3221선 마감",
        date: '2021.06.01',
        description: `개인·외인 매도에 기관 매수세 키워

        [서울=뉴시스]고범준 기자 = 코스피가 전 거래일 대비 17.95포인트(0.56%) 오른 3,221.87에 마감한 1일 오후 서울 중구 하나은행 딜링룸에서 딜러들이 업무를 보고 있다. 이날 코스닥지수는 전 거래일 대비 2.81포인트(0.29%) 오른 984.59에, 서울 외환시장에서 원·달러 환율은 전 거래일보다 5.0원 내린 1,105.9원에 마감했다. 2021.06.01. bjko@newsis.com
        
        
        [서울=뉴시스] 김제이 기자 = 빠르게 지수를 회복한 코스피가 최고가 경신을 눈앞에 두고 있다. 1일 지수는 3거래일 연속 상승세를 이어가며 단숨에 3221선에 도달했다.
        
        이날 코스피지수는 전 거래일(3203.92)보다 17.95포인트(0.56%) 오른 3221.87에 마감했다. 지수는 전일 대비 3.20포인트(0.10%) 오른 3207.12에 출발한 뒤 장 초반 등락을 겪은 후 완만한 상승 흐름을 이어갔다.
        
        지수는 3거래일 연속상승에 성공하며 종가 기준 최고가(3249.30, 5/10)와의 간격을 대폭 줄였다. 지수가 상승 추세를 이어간다면 사상 최고가 경신을 다시 한번 기록할 수 있을 전망이다.
        
        유가증권시장에서는 개인은 6148억원, 외국인은 365억원 각각 순매도했다. 기관은 6538억원 순매수했다.
        
        업종별로는 등락이 교차했다. 상승한 업종은 섬유의복(3.62%), 통신업(2.32%), 유통업(1.64%), 증권(1.33%), 운수장비(1.28%) 등이며, 내린 업종은 의약품(-1.01%), 철강금속(-0.51%), 운수창고(-0.45%), 의료정밀(-0.45%), 은행(-0.41%) 등이다. 
        
        시가총액 상위 종목들도 희비가 갈렸다. 삼성바이오로직스(-1.54%), 셀트리온(-0.73%) 등은 하락했으나 카카오(3.25%), 네이버(1.24%), SK하이닉스(1.18%), 현대차(0.85%), LG화학(0.73%), 삼성SDI(0.16%), 삼성전자(0.12%), 기아차(0.12%)는 올랐다.
        
        코스닥지수는 전 거래일(981.78)보다 0.47포인트(0.05%) 오른 982.25에 출발한 뒤 2.81포인트(0.29%) 오른 984.59에 마감했다.
        
        코스닥시장에서는 기관은 715억원, 외국인은 169억원 각각 순매도했다. 개인은 982억원 순매수했다.
        
        코스닥 시총 상위 10개 종목은 10개 종목 중 알테오젠(-3.70%), 펄어비스(-1.49%), 셀트리온헬스케어(-0.99%), 셀트리온제약(-0.22%) 등은 하락했다. 에이치엘비(4.22%), 씨젠(0.89%), 에코프로비엠(0.51%), 카카오게임즈(0.38%), SK머티리얼즈(0.12%), CJ ENM(0.06%) 등은 상승했다.
        
        한편, 이날도 전날에 이어 중국 정부가 자녀 출산을 세 명까지 허용하기로 하면서 관련 기업의 주가가 올랐다.
        
        아가방 컴퍼니는 전날 2.48% 상승 뒤 이날도 3.11%로 상승했다. 토박스는 5% 가까이 올랐으며 캐리소프트도 0.77% 상승세를 기록했다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/008/2021/05/25/0004591756_001_20210525075302165.jpg",
        title: "일제히 반등한 뉴욕 증시…'부진했던 반도체 업종도 훈풍 가능성 ↑'",
        date: '2021.05.25',
        description: `[머니투데이 구단비 기자] [개장전]


        지난 24일 오후 서울 중구 하나은행 딜링룸에서 관계자들이 업무를 보고 있다. 이날 코스피 지수는 전 거래일보다 12.12포인트(0.38%) 떨어진 3144.30으로 장을 마쳤다. 코스닥은 17.26포인트(1.79%) 떨어진 948.37, 원달러 환율은 0.1원 오른 1127.10원을 기록했다. /사진=뉴스1
        
        인플레이션 우려가 사그라지면서 뉴욕 증시의 3대 지수들이 일제히 반등했다. 특히 대형기술과 경제재개 관련주들이 증시 상승을 이끌었다. 전문가들은 최근 약세를 보였던 반도체 업종들이 미국발 훈풍에 힘입어 상승할 가능성이 있다고 봤다.
        
        24일(현지시간) 뉴욕증시에서 블루칩(우량주) 클럽인 다우존스산업평균지수는 전 거래일보다 186.14포인트(0.54%) 상승한 3만4393.98로 장을 마쳤다. 
        
        대형주 중심의 S&P(스탠다드앤푸어스)500지수는 전장보다 41.19포인트(0.99%) 오른 4197.05를 기록했다.
        
        기술주 중심의 나스닥 종합지수는 전날보다 190.18포인트(1.41%) 뛴 1만3661.17로 마감했다.
        
        이날 뉴욕증시는 미국의 인플레이션 우려와 중국의 가상화폐 규제 영향에서 벗어나 기술주 강세를 통해 회복하는 모양새를 보였다. 기술주의 경우 비트코인이 큰 폭으로 반등하자 강한 동조화 현상에 따라 덩달아 상승했다.
        
        물가 상승 우려가 진정되자 미국 10년물 국채금리도 1.603%까지 하락했다. 지난주 1.7%까지 치솟았던 국채금리가 1.5%대를 다시 진입할 것이라는 기대치가 커졌다.
        
        조 바이든 대통령의 행정부는 사회기반시설 지출안의 규모를 기존보다 줄인 2조달러 미만으로 공화당에 제안했고, 브레이너드 연준 이사도 연설을 통해 단기적인 물가 압력은 커지겠지만 이는 일시적일 것이라는 전망을 밝히며 시장을 안심시켰다.
        
        서상영 미래에셋증권 연구원은 "브레이너드 연준 이사 발언과 더불어 이날 발표된 4월 시카고 연근 국가 활동 지수가 8개월 최고치였던 지난달 1.71에서 0.24로 하락해 경기 회복 속도가 둔화되고 있음을 시사했다"며 "연준의 온건한 통화정책 기대를 높인다는 점에서 국채 금리 하락의 주요 요인으로 작용했다"고 설명했다.
        
        이어 "오늘 한국 증시는 전날과 달리 미 증시 기술주 중심 강세를 감안해 성장주 중심의 강세가 예상된다"며 "필라델피아 반도체 지수 2.32% 상승은 한국 증시에서 관련 종목군의 상승 가능성을 높이고 있다"고 진단했다.
        
        그러면서 "다만 미국 국무부가 코로나19를 이유로 일본 여행을 금지하는 권고를 발표한 점은 주목해야 한다"며 "일본 증시가 올림픽 취소 이슈 재부각에 따른 변동성 확대 가능성이 높아져 한국 주식시장에도 부담으로 작용할 수 있기 때문"이라고 했다.
        
        서 연구원은 "한국 증시는 달러 약세와 국제유가 상승 등을 기반으로 0.5% 내외 상승 출발이 예상되지만 상승폭 확대보단 아시아 주변 시장의 움직임에 따라 변화가 예상된다"고 덧붙였다.
        
        한지영 키움증권 연구원도 필라델피아 반도체 지수 급등에 따른 국내 반도체 업종 주가 상승 가능성이 있다고 봤다. 그는 "한국 증시는 미국발 훈풍과 전거래일 낙폭이 컸던 중소형주들의 저가 매수세 유입 등에 힘입어 상승 흐름을 보일 것"이라고 예상했다.
        
        이어 "최근 국내 증시는 업종간 순환매가 빠른 속도로 진행되고 있는 가운데 장중 수급 주체들 간에도 매매패턴이 일정하지 않아 시장 대응을 어렵게 만들고 있다"며 "그러나 전거래일 미국 증시의 성장주, 가치주 동반 강세 현상에 따라 금일 국내 증시에서도 단기적 순환매 장세가 진정되며 우호적 환경이 조성될 것"이라고 예측했다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/05/18/0004932875_001_20210518154601728.jpg",
        title: `[외환마감]환율, 4원 가량 내려 1130원 초반 하락.."위험선호 회복"`,
        date: '2021.05.18',
        description: `미국채 금리 1.6% 중반 등락, 달러인덱스 90포인트선 하락
        뉴욕지수 선물 3대지수 일제히 상승, 코스피도 상승 전환
        
        사진=AFP
        [이데일리 이윤화 기자] 원·달러 환율이 4원 가량 내려 2거래일만에 하락 마감했다. 뉴욕지수 선물과 코스피 지수가 상승하는 등 금융시장 전반에 위험선호가 회복되자 달러가 약세로 돌아섰다. 
        
        
        18일 서울외국환중개에 따르면 원·달러 환율은 전 거래일(1134.8원)보다 4.3원(0.38%) 하락한 1130.5원에 거래를 마쳤다. 이날 환율은 전 거래일보다 전 거래일보다 1.2원 상승한 1136원에 출발해 1130원대 중후반에서 등락하다가 오전 10시반께 하락 전환했다. 장중 한 때 1137.5원까지 올랐지만 오후 들어 낙폭을 키우더니 1130원 초반대로 밀렸다. 
        
        미 국채 10년물 금리는 1.6%대, 달러인덱스는 90포인트선에서 등락하는 중이다. 18일 오전 2시 반시께(현지시간) 10년물 국채 금리는 전일 대비 0.007%포인트 오른 1.647을 기록하고 있다. 달러인덱스는 뉴욕증시 증시 종가 대비 0.151%포인트 내린 90.005를 기록하고 있다. 
        
        뉴욕지수 선물 상승세를 보이고 있다. 다우지수 선물은 전 거래일 대비 0.44% 오른 3만4407을 기록하고 있다. 스탠더드 앤드 푸어스(S&P) 500 지수 선물도 0.41% 상승한 4175를 기록하고 있다. 나스닥 100 선물은 0.7% 뛴 1만3396에 거래되고 있다. 
        
        국내증시는 외국인과 개인의 매도세에도 기관의 매수 우위에 1거래일 만에 상승 전환했다. 코스피 지수는 전일 대비 38.53포인트(1.23%) 오른 3173.05에 장을 마감했다. 개인과 외국인이 각각 6396억원, 3498억원 가량 팔았다. 기관은 9742억원 가량 매수했다. 
        
        이날 서울외국환중개와 한국자금중개에서 거래된 자금은 97억200만달러다.
        `,
    },
    {
        src: "https://imgnews.pstatic.net/image/011/2021/05/18/0003911357_001_20210518052201530.jpeg",
        title: "연준 의사록 공개 앞두고 美 증시약세···다우, 0.16% 하락 [데일리 국제금융시장]",
        description: `애플 등 기술주 1% 가까이 하락
        AT&T 최고치 기록 후 하락 마감
        
        
        [서울경제] 
        
        미국 뉴욕증시가 19일(현지 시간) 연방준비제도(Fed·연준) 의사록 공개를 앞두고 약세를 보였다. 
        
        17일 미 경제 방송 CNBC와 투자 전문지 배런스에 따르면 이날 뉴욕증권거래소(NYSE)의 다우존스산업평균지수는 전 거래일보다 54.34포인트(0.16%) 내린 3만4,327.79에 거래를 마쳤다. 스탠더드앤드푸어스(S&P)500은 10.56포인트(0.25%) 떨어진 4,163.29, 나스닥은 50.93포인트(0.38%) 하락한 1만3,379.05에 마감했다. 
        
        시장은 인플레이션 공포가 지속되는 가운데 수요일(19일)에 나올 연준 의사록에서 긴축 여부에 대한 가늠이 가능할 것으로 보고 있다. 이날 페이스북(-0.15%)과 넷플릭스(-0.90%), 애플(-0.93%) 등 주요 기술주가 하락했다. AT&T와 디스커버리의 합병소식에 AT&T 주가는 장초반 사상 최고치를 기록했지만 결국 2.7% 하락 마감했다. 
        
        국제유가는 미국과 유럽의 경기회복 기대에 상승했다. 이날 뉴욕상업거래소의 6월물 서부 텍사스산 원유(WTI) 가격은 전 거래일보다 90센트(1.4%) 오른 배럴당 66.27달러에 거래를 마쳤다. 이는 2019년 4월23일(66.30달러) 이후 최고치다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/008/2021/05/14/0004587358_001_20210514065401261.jpg",
        title: `인플레 '저항력' 세진 증시, "강세장 더 간다" [뉴욕마감]`,
        date: '2021.05.14',
        description: `[머니투데이 뉴욕=임동욱 특파원] 전날 급락했던 뉴욕증시가 반등했다. 전날 시장에 공포감을 줬던 인플레이션에 대해 '저항력'이 강해진 모습이다. 

        3대 지수 동반 반등
        
        월가_황소상
        
        13일(현지시간) 뉴욕증시에서 블루칩(우량주) 클럽인 다우존스산업평균지수는 전 거래일보다 433.79포인트(1.29%) 오른 3만4021.45로 거래를 마쳤다. 
        
        대형주 중심의 S&P500지수는 전날보다 49.46포인트(1.22%) 오른 4112.50으로 장을 마쳤다. 
        
        기술주 중심의 나스닥 종합지수는 93.31포인트(0.72%) 오른 1만3124.99로 마감했다. 기술주들은 엇갈린 모습을 보였다. 애플과 마이크로소프트는 각각 1.79%, 1.69% 오른 반면, 테슬라는 3.09% 하락했다. 
        
        쿠팡은 1분기 실적 발표 이후 9.31% 급락했다. 
        
        장기 국채금리는 하락했다. 이날 1.700%으로 출발한 미국 10년 만기 국채수익률은 1.661%로 떨어졌다. 
        
        "강세장 더 갈 것"...인플레 악재에 '무덤덤'
        
        
        치솟는 물가에 대한 우려로 전날 급락했던 증시는 이날 반등했다. 전날과 사뭇 달라진 분위기다. 
        
        AB번스타인의 이니고 프레이저-젠킨스 전략가는 "전날의 인플레이션 수치가 경제 재개 이후 장기적인 인플레이션을 변화시킨다고 생각하지 않는다"며 "이는 궁극적으로 시장에 중요한 문제"라고 밝혔다. 
        
        트루이스트의 케이스 러너 최고시장전략가는 "이번 강세장은 궁극적으로 더 갈 것"이라며 "주식비중이 낮은 투자자들은 시장 약세를 기회로 삼아 더욱 공격적으로 나서야 한다"고 밝혔다. 
        
        이날 시장 전망치를 크게 뛰어넘는 또다른 인플레 데이터가 나왔지만 시장은 별다른 반응을 보이지 않았다. 
        
        미국 4월 생산자물가는 시장 예상치를 크게 상회하는 상승세를 기록했다. 소비자물가에 이어 생산자물가까지 함께 뛰면서 인플레이션 압력이 높아질 전망이다.
        
        이날 미 노동부에 따르면 4월 생산자 물가지수(PPI)는 전달대비 0.6% 상승했다. 이는 블룸버그가 실시한 설문조사 전망치(0.3%)를 2배 가량 웃도는 수치다.
        
        연료, 식품을 제외한 근원 PPI는 0.7% 상승하며 시장 예상치 0.4%를 상회했다.
        
        연간 기준 도매 인플레이션 상승률은 3월 4.2%에서 6.2%로 급등했다. 이는 2009년 이후 최고치다.
        
        시장은 생산 원가가 계속 상승하는 가운데 소비자물가가 그 뒤를 따르고 있다고 보고 있다. 미 연방준비제도는 이번 물가 상승이 '일시적'인 것이라고 수차례 강조하고 있지만, 시장은 반신반의하는 분위기다.
        
        이미 일부 제조기업들은 원가 부담을 판매가격 인상을 통해 소비자에게 넘기고 있다.
        
        킴벌리-클락의 마이클 슈 최고경영자는 지난달 "스콧 화장지와 하기스 기저귀가 원자재값 상승 역풍을 상쇄하기 위해 판매가격을 인상하며 빠르게 움직이고 있다"고 밝힌 바 있다.
        
        BMO캐피털마켓의 제니퍼 리 선임이코노미스트는 "생산자들이 (생산 원가 상승의) 고통을 소비자와 나누기 시작하기 전까지 감당해 내야 할 부담이 너무 크다"고 진단했다.
        
        한편 전날 발표된 4월 소비자물가지수(CPI)는 전월 대비 0.8% 급등하며 2009년 이후 가장 큰 폭의 월간 상승률을 기록했다. 이는 다우존스와 월스트리트저널이 조사한 전망치 0.2%를 크게 뛰어넘는 수치다.
        
        연간 물가상승율은 지난 3월 2.6%에서 4.2%로 치솟으며 2008년 이후 최고치를 기록했다.
        
        에너지, 식품을 제외한 근원 CPI는 전달대비 0.9% 상승했다. 이는 1982년 이후 최고치다.
        
        4월에는 거의 대부분 품목의 가격이 급등했다. 중고차 가격은 사상 최고치를 경신했다. 음식값도 팬데믹 이전보다 2배나 빠르게 올랐다.
        
        블룸버그는 이번 CPI 급등에 대해 "팬데믹으로 가장 큰 타격을 입은 업종들이 다시 문을 열고 백신 접종을 마친 미국인들이 활동을 재개함에 따라 자동차, 교통서비스, 호텔 숙박료 등이 급격히 상승한 결과"라고 진단했다.
        
        이같은 물가 급등세는 경제에 상당한 부담을 줄 전망이다.
        
        마켓워치는 "인플레이션이 급격히 상승해 당분간 높은 수준을 유지할 전망"이라며 "기업들은 적시에 합리적인 가격으로 필수 물자들을 공급받지 못하고 있으며, 이제 인건비가 오르고 있다"고 밝혔다.
        
        일부 경제학자들은 미국이 수십 년만에 최악의 인플레이션 사태 직전에 있다고 경고한다. 정부의 대규모 경기부양책이 물가 문제를 자극하고 있으며, 연방준비제도(연준, Fed)가 너무 태만하게 이 문제를 다루고 있다는 지적이다.
        
        美 CDC "백신 다 맞았으면 마스크 안 써도 돼"
        
        [라스베이거스=AP/뉴시스]27일(현지시간) 미 네바다주 라스베이거스에서 마스크를 쓰거나 쓰지 않은 보행자들이 거리를 걷고 있다. 미국 질병통제예방센터(CDC)는 코로나19 백신 접종을 완료한 경우 야외에서 마스크를 쓰지 않아도 된다고 발표하며 야외 마스크 착용에 대한 지침을 완화했다. 2021.04.28.
        
        미국에서 백신 접종을 완전히 마친 사람은 대부분의 상황에서 마스크를 벗을 수 있게 된다. 이같은 소식에 아메리칸항공,유나이티드항공, 델타항공 등 항공주가 각각 2%대 상승률을 기록했다. 
        
        로셸 왈렌스키 미국 질병통제예방센터(CDC) 국장은 13일(현지시간) 백악관 브리핑에서 "백신을 완전히 접종한 사람은 크고 작은 실·내외 활동에 마스크를 쓰거나 거리두기를 할 필요 없이 참여할 수 있다"고 밝혔다.
        
        왈렌스키 국장은 "백신을 완전히 접종했다면, 코로나19로 인해 중단했던 일들을 다시 시작할 수 있다"며 "우리 모두는 정상으로 돌아갈 수 있는 이 순간을 갈망해 왔다"고 말했다.
        
        그러나 백신 완전 접종자라도 △병원, 요양원 등 장기요양시설 △버스, 비행기, 기차 등 공공교통수단 △공항, 버스정류장 △감옥, 노숙자쉼터 등을 방문하거나 이용할 때는 마스크를 써야 한다.
        
        블룸버그에 따르면, 미국 성인의 약 59%가 적어도 1회 이상 코로나19 백신을 접종했다. 조 바이든 미국 대통령은 미국 성인의 70%가 7월4일까지 최소 1회의 백신을 맞게 한다는 계획을 세운 바 있다.
        
        지난 4월 말 CDC는 완전 백신 접종을 한 사람들에 대해 소규모 그룹으로 야외에서 운동, 식사, 사교 활동을 하거나, 완전히 백신 접종을 마친 사람들과 실내에서 만날 때 마스크를 벗을 수 있다는 지침을 발표했다.
        
        
        [골드스미스=AP/뉴시스]21일(현지시간) 미 텍사스주 골드스미스 인근 유정의 원유시추기 펌프잭 뒤로 해가 지고 있다. 2021.04.22.
        
        유가는 내렸다.
        
        뉴욕상업거래소(NYMEX)에서 WTI(서부 텍사스산 원유) 6월 인도분은 배럴당 2.29달러(3.47%) 내린 63.79달러를 기록했다. 
        
        런던 ICE 선물거래소에서 오후 10시28분 기준 국제유가의 기준물인 6월분 북해산 브렌트유는 배럴당 2.32달러(3.35%) 내린 67.00달러에 거래 중이다. 
        
        금 가격은 올랐다. 이날 뉴욕상품거래소에서 6월 인도분 금 가격은 전 거래일보다 온스당 4.00달러(0.22%) 오른 1826.80달러에 거래를 마쳤다. 
        
        달러화는 보합세다. 오후 5시29분 현재 뉴욕외환시장에서 달러인덱스(DXY)는 전날과 같은 90.72를 기록 중이다. 달러인덱스는 유로, 엔 등 주요 6개 통화를 달러화 가치를 지수화한 것이다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/277/2021/05/12/0004901125_001_20210512081803548.jpg",
        title: "[굿모닝 증시]인플레이션 공포 불안감…경계 심리 가득해도 반등 시도",
        date: '2021.05.12',
        description: `[아시아경제 이선애 기자] 시장 참여자들은 인플레이션 급등이 추세적일지에 대한 불안감을 해소하지 못하고 있다. 다만 미국 연방준비제도(연준) 위원들의 시장 달래기 발언은 지속되고 있다. 인플레이션 급등세가 지속적으로 진행될 가능성은 작으므로, 추세적인 인플레이션 급등에 대한 베팅은 시기상조라는 판단하에 국내 증시는 경계심리를 품고 반등은 시도할 전망이다. 

        ◆뉴욕증시, 인플레 공포에 출렁= 간밤 뉴욕증시가 출렁였다. 11일(현지시간) 뉴욕증권거래소(NYSE)에서 다우존스30 산업평균지수는 전장보다 473.66포인트(1.36%) 하락한 3만4269.16으로 장을 마쳤다. 스탠더드앤드푸어스(S&P)500지수는 36.33포인트(0.87%) 밀린 4152.10을, 나스닥지수는 전장보다 12.43포인트(0.09%) 떨어진 1만3389.43으로 장을 마감했다.
        
        투자자들은 유럽과 중국 등 전 세계 경제 지표가 개선되고 있다는 소식에 인플레이션이 가속화될 것이라는 점을 우려했다. 일부 투자자들은 이 같은 인플레이션 상승이 연준의 조기 긴축을 촉발할 수 있다고 걱정했다. 이에 월가의 '공포지수'로 불리는 시카고옵션거래소(CBOE) 변동성지수(VIX)는 이날 23.73까지 오르며 3월10일 이후 최고치를 기록했다. 인플레이션 우려를 반영해 미국 10년물 국채금리도 장중 1.62%를 넘어서기도 했다.
        
        서상영 미래에셋증권 연구원은 "경제 정상화 기대로 강세를 보여오던 일부 산업재, 소비재, 금융주가 약세를 보였다"며 "인플레 압력이 높아지고 있다는 점을 감안해 관련 기업들에 대한 매물이 지속되는지 여부는 좀 더 면밀하게 살펴볼 필요가 있다"고 말했다.
        
        
        
        
        ◆한지영 키움증권 연구원= 11일 한국 증시는 전거래일 미국 기술주 급락 충격으로 하락 출발한 가운데 장 중반에는 코스피, 코스닥 모두 2% 가까운 낙폭을 기록하기도 했다. 그러나 이 같은 급락세가 과도했다는 인식 속 5월(10일까지 기준) 수출 소식 등에 힘입어 장 중반 이후부터 반등에 나서면서 낙폭을 축소한 채로 마감(코스피 -1.2%, 코스닥 -1.4%)했다.
        
        업종별로는 미국 필라델피아 반도체지수 급락에 따른 전기전자(-2.0%) 포함한 서비스(-1.8%), 제조(-1.5%), 종이·목재(-1.5%) 등 전 업종이 약세를 보였다. 또한 외국인과 기관은 각각 2조3000억원, 1조4000억원 동반 순매도에 나서면서 지난 2월 이후 해당 수급 주체 모두 최대 순매도에 나서는 등 수급 상으로도 하방 압력이 심화됐다.
        
        한국 증시는 반도체를 포함한 대형주를 중심으로 낙폭 과대 인식성 매수세가 유입되면서 반등을 시도할 전망이다. 물론 현 지수대에서 차익실현 욕구가 상존한 가운데 미국의 4월 소비자 물가지표 결과를 둘러싼 경계심리가 부담요인이 될 수는 있다. 그러나 전거래일 미국 기술주 및 필라델피아 반도체 지수 반등, 달러화 약세 등은 국내 증시에서 긍정적인 영향을 줄 것으로 예상한다. 또한 대부분 연준 위원들이 인플레이션 급등을 일시적으로 바라보고 있으며, 정책 정상화를 조기에 하지 않을 것이라는 의지를 표명했다는 점도 시장 불안 심리 개선에 기여할 전망이다. `,
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/05/09/0004924492_001_20210509214501471.jpg",
        title: "[주간증시전망]인플레 방향 어디로…美물가지표·연준 발언 주목",
        date: '2021.05.09',
        description: `2분기 실적 긍정적…공매도도 펀더멘털 주가 흐름
        "코스피 2Q 영업익 컨센 3월 말比 7.8% 상향"
        인플레이션 경계감 예상…긴축 우려는 제한적
        [이데일리 이은정 기자] 한주간 국내 증시가 미국 인플레이션 우려, 아시아 증시 전반 휴장에 보합권에서 등락을 이어갔다. 공매도 부분재개 속 개별 종목 펀더멘털에 따른 주가 흐름이 예상되는 가운데 미국 연방준비제도(Fed) 인사들의 발언과 4월 물가지표 등이 주목된다. 
        
        
        재닛 옐런 전 연방준비제도(Fed) 의장. (사진=AFP 제공)
        9일 마켓포인트에 따르면 지난주(5월3일~5월7일) 코스피는 0.15% 오른 3197.20으로 마감했다. 코스닥은 2.09% 내린 978.30을 기록했다. 지난 3일 공매도가 코스피200·코스닥150에 부분재개됐고 바이오를 중심으로 게임, 전자부품 업종 등에 대해 거래가 이뤄졌다. 각종 기대감에 밸류에이션을 상향조정 받았던 중소형주 중심으로 변동성이 확대됐다. 
        
        국내 기업들의 1분기 실적발표가 맞물리면서 펀더멘털이 양호한 종목은 공매도 영향을 빗겨갈 전망이다. 실적이 개선되는 기업 주가가 수급 영향으로 지속 하락하긴 어렵다는 분석이다. 실적 발표가 마무리되는 이번주(5월 둘째주)엔 1분기 어닝 서프라이즈 효과를 기대할 수 있는 마지막 주기도 하다.
        
        이제 관심은 2분기 실적에 쏠리고 있다. 
        
        김영환 NH투자증권 연구원은 “코스피 2분기 영업이익 컨센서스는 3월 말 대비 7.8% 상향, 밸류에이션 부담은 13배 수준으로 경감돼 양호한 매크로·기업실적 전망에 코스피 상승 흐름을 예상한다”며 “주식시장 불안 요인은 테이퍼링 이슈인데 원자재 가격 상승이 수요 회복과 함께 공급 병목 현상에 의해 나타나는 부분이 있어 테이퍼링이 빠르게 공론화되진 않을 공산이 크다고 본다”고 말했다. 
        
        지난주에는 미국 재무부와 연준에서 잇달아 시장의 변동성을 키우는 발언이 이어졌다. 지난주 옐런 미국 재무장관의 금리인상 발언으로 인플레이션 경계는 이어질 것으로 보인다. IBK투자증권은 다른 연준 관계자들이 조기 긴축 우려를 진화하고 있지만 발언 당사자인 옐런이 연준 의장을 역임한 비둘기파적인 인물이란 점에서 파장이 있을 것으로 봤다.
        
        박희찬 미래에셋증권 연구원은 “이런 상황(금리인상 가능성 제기)은 반복적으로 나타날 가능성이 높을 것”이라며 “자본소득세 이슈도 불확실하게 남아 있기 때문에 기술성장주에 대한 차익실현, 경제정상화·금리상승 컨셉으로의 로테이션 현상은 좀더 지속될 가능성이 커 보인다”고 전했다. 
        
        미국 연준이 6일(현지시간) 금융안정보고서를 통해 자산버블 붕괴를 경고했다는 점도 부담이다. 시중 유동성이 주식과 가상화폐 등으로 몰리는 가운데 버블경고가 나오면서 긴축 시기가 앞당겨질지 관심이 쏠린다. 
        
        다만 급격한 긴축 기조 전환 가능성은 적을 것으로 보고 있다. 미국 10년물 국채금리는 지난 7일(현지시간) 3월 초 이후 두 달 만에 가장 낮은 수준을 기록하며 1.5%를 하회하기도 했다. 기준금리 결정에 상당한 영향을 미치는 미국 4월 비농업 부문 신규 취업자수는 26만6000명으로 마켓워치의 전문가 설문조사 전망치인 100만명에 크게 못 미쳤다. 실업률도 예상보다 높은 6.1%를 기록했다. 금리 인상 부담을 덜 요인으로 꼽힌다. 
        
        이번주 발표되는 4월 미국 소비자물가에 관심이 높다. 증권가는 지난해 대비 기저효과가 클 전망인 만큼 전월 대비 상승률을 봐야 한다고 조언한다. 소비자물가지수(CPI)가 2개월 연속 전월비 0.3%를 기록하면 옐런 장관의 금리인상 의견을 지지하는 세력들도 늘어나게 될 것이란 분석이다. 
        
        안소은 IBK투자증권 연구원은 “4월 물가 지표는 기저효과와 최근 불거진 공급 이슈로 급격한 상승이 불가피한 가운데 고용 지표는 아직 덜 회복됐고 임금 상승세도 약하다”며 “중앙은행이 기다리는 수요측 물가 상승 압력이 가시화되기 이전에는 급격한 긴축 기조 전환 가능성은 낮을 것”이라고 말했다. 
        
        NH투자증권은 이번주 코스피 지수가 3110~3230포인트선이 될 것으로 전망했다. 상승 요인으로는 경기 호조, 실적 전망에 따른 코스피 밸류에이션 완화, 하락 요인으로는 인플레이션 압력 상승에 따른 테이퍼링 우려를 꼽았다. 
        
        김 연구원은 “4월 제조업지수 하락이 수요부진이 아닌 공급차질에 의해 나타나고 있는 것을 의미해 이연된 수요 효과가 나타날 수 있다는 점에서 경기를 긍정적으로 판단한다”며 “각종 원자재 가격 상승세와 미국 금리인상 우려에 따른 금융시장 불안감은 쉽게 진정되지 않아 주식시장 하방 압력으로 작용할 공산이 있다”고 전했다. 
        
        
        NH투자증권은 이번주(5월10일~5월14일) 주목할 만한 이벤트로 △ 11일 중국 4월 소비자물가 △11일 석유수출국기구(OPEC) 월간 보고서 △12일 3월 유로존 산업생산 △12일 미국 4월 소비자물가 △13일 미국 4월 생산자물가 △14일 미국 4월 소매판매·산업생산 발표 등을 제시했다. 
        
        11일 존 윌리암스 연준 총재가 연설에 나서는 SOFR 심포지엄에서 초과지준부리 인상에 대한 논의가 나올 가능성도 제기된다. 아울러 증권가는 긴축으로 시장 전반 투자심리가 위축되는 게 아니라면 인플레 수혜 업종인 산업재·소재·금융 중심 대응도 적절하다는 판단을 내놨다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/011/2021/05/03/0003905138_001_20210503093004301.jpg",
        title: "[오전시황] 공매도 재개 첫 날 코스피 등락 거듭···개인·기관 순매수",
        date: '2021.05.03',
        description: `[서울경제] 

        공매도가 1년 2개월 만에 재개된 첫 날 국내 증시는 등락을 거듭하고 있다. 개인과 기관이 순매수하며 지수를 이끌고 있지만, 외국인의 대량 매도에 박스권 행보를 보이고 있다. 
        
        3일 오전 9시 21분 현재 코스피지수는 전날보다 2.72포인트(0.09%) 오른 3,150.58을 기록 중이다. 이날 코스피는 전 거래일보다 1.19포인트(0.04%) 오른 3,149.05 출발했으나, 등락을 반복하고 있다. 
        
        거래 주체별로는 개인투자자외 기관이 각각 756억원, 676억원을 순매수 중이나 외국인이 1,416억원을 순매도 하고 있다. 시가총액 상위 종목들도 혼조세다. 삼성전자(005930)(0.61%), SK하이닉스(000660)(1.56%), NAVER(1.53%), 카카오(035720)(1.32%), 현대차(005380)(2.12%) 등이 상승세를 보이고 있다. 반면 LG화학(-2.47%), 삼성바이오로직스(-0.62%), 삼성SDI(-0.76%), 셀트리온(-2.63%) 등이 전일보다 하락세를 보이고 있다. 
        
        같은 시각 코스닥지수는 전날보다 7.85포인트(0.80%) 내린 975.60에 거래 중이다. 코스닥 시장에서는 개인과 기관이 각각 226억원, 47억원을 순매수하고 있으나, 기관이 223억원을 순매도하고 있다. 
        
        지난 주 금요일 뉴욕 증시는 기업들의 실적과 경제지표의 호조에도 고점에 대한 부담감에 하락세를 보였다. 30일(현지 시간) 미국 뉴욕증권거래소에서 스탠더드앤드푸어스(S&P)500 지수는 전 거래일보다 0.72% 내린 4,181.17에 거래를 마쳤다. 다우존스 30 산업평균지수는 전날보다 0.54% 내린 3만 3,874.85에, 나스닥 지수는 전장보다 0.85% 내린 1만 3,962.68로 마감했다. 기업들이 예상을 웃도는 실적을 발표하고 있지만, 그 전날 S&P500이 사상최고치를 경신하는 등 높은 밸류에이션 부담에 따른 차익실현 매물이 출회되며 증시에 하방 압력을 가한 것으로 풀이된다. `,
    },
    {
        src: "https://imgnews.pstatic.net/image/001/2021/04/29/AKR20210429002100098_01_i_P4_20210429014609698.jpg",
        title: "[유럽증시] FOMC 결정 주시 속 소폭 상승",
        date: '2021.04.29',
        description: `(브뤼셀=연합뉴스) 김정은 특파원 = 유럽 주요 증시는 28일(현지시간) 소폭 상승하며 마감했다.

        이날 영국 런던 증시의 FTSE 100 지수는 전 거래일 종가 대비 0.27% 상승한 6,963.67로 거래를 마쳤다.
        
        독일 프랑크푸르트 증시의 DAX 30 지수는 0.28% 상승한 15,292.18로, 프랑스 파리 증시의 CAC 40 지수 역시 0.53% 오른 6,306.98로 장을 마감했다.
        
        범유럽지수인 유로 Stoxx 50 지수도 0.08% 상승한 4,015.03으로 거래를 종료했다. 
        
        시장은 이날 예정된 미국 연방준비제도(연준·Fed)의 연방공개시장위원회(FOMC) 정례회의와 조 바이든 대통령의 취임 후 첫 의회 연설, 기업 실적 발표, 신종 코로나바이러스 감염증(코로나19) 백신 접종 상황을 주시했다. 
        
        바이든 대통령은 이번 연설에서 전염병 대유행 억제 성과를 소개하면서 미국의 미래를 위한 인프라 투자에 초점을 맞출 것으로 알려졌다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/366/2021/04/22/0000706050_001_20210514013009517.jpg",
        title: "[마켓뷰] 코스피, 외국인·연기금 매도에도 소폭 상승",
        date: '2021.04.22',
        description: `코스닥은 0.34% 상승 마감

        22일 코스피지수가 상승 마감했다. 외국인과 기관이 동반 매도에 나선 반면, 개인 투자자들은 3500억원 가까이 순매수했다.
        
        
        조선DB
        
        이날 코스피지수는 전날보다 5.86포인트(0.18%) 오른 3177.52로 마감했다.
        
        유가증권시장에서 개인은 총 3493억원어치를 사들였다. 반면 외국인과 기관은 각각 1486억원, 2355억원을 순매도했다. 기관 투자자 중 연기금은 총 1983억원어치를 팔며 4거래일 연속 순매도를 이어가고 있다. 이달 들어 연기금의 누적 순매도액은 2조3113억원을 돌파했다.
        
        외국인도 순매도를 이틀 연속 계속하고 있다. 외국인 투자자들은 전날인 21일 하루만에 1조4286억원을 순매도한 바 있다. 이는 국내 주식시장이 개장한 이래 여섯번째로 많은 규모다.
        
        최유준 KB증권 연구원은 "앞서 올해 1월에도 코스피지수가 역대 최고치를 경신한 후 외국인의 차익 실현 매물이 나왔다"며 "4월 들어 코스피지수가 15거래일 중 13일이나 상승하며 다시 신고가에 근접하자, 외국인 투자자들의 차익 실현 욕구가 커진 것 같다"고 설명했다.
        
        실제로 지난 1월 11일 코스피지수가 사상 최고치인 3266.23을 기록하자, 외국인의 차익 실현 매물이 출회됐다. 11~12일 이틀 간 1조3365억원이 순매도됐다.
        
        최 연구원은 "다만, 1월과 달리 현재는 상승장이 주가수익비율(PER) 상승이 아닌 이익 증가 덕에 이어지고 있다"고 분석했다. 1월에는 상장사들의 밸류에이션(기업 가치 대비 주가 수준)이 높아지는 추세였다면, 최근에는 기업의 실적 개선이 주가 상승을 뒷받침하고 있다는 얘기다. 그는"증시의 체력이 더 강해진 상태이기 때문에, 향후 코스피지수의 변동성이 크지는 않을 것"이라고 전망했다.
        
        한편, 이날 코스닥지수는 전날보다 3.49포인트(0.34%) 오른 1025.71로 마감했다. 전고점인 1032.64(4월 20일 기준)를 경신하지는 못했다.
        
        유가증권시장과 달리 코스닥시장에서는 외국인과 기관의 동반 매수세가 강하게 나타났다. 개인은 415억원을 순매도했으나, 외국인과 기관은 각각 220억원, 321억원을 순매수했다.
        
        연기금은 코스닥시장에서 9거래일 연속 순매수를 기록하며 새로운 ‘큰 손’으로 떠올랐다. 9일 간 연기금은 코스닥시장에서 총 2059억원어치를 사들였다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/011/2021/04/22/0003900527_001_20210422070705475.jpg",
        title: "뉴욕증시, 경제 재개 수혜주 반등에 3일만 상승 마감[데일리 국제금융시장]",
        date: '2021.04.22',
        description: `뉴욕증시는 경제 재개에 수혜를 보는 종목들이 오름세를 보이면서 3거래일 만에 상승세로 마감했다.

        21일(미 동부시간) 뉴욕증권거래소(NYSE)에서 다우존스30산업평균지수는 전장보다 316.01포인트(0.93%) 오른 34,137.31을 기록했다. 스탠더드앤드푸어스(S&P)500지수는 전장보다 38.48포인트(0.93%) 상승한 4,173.42를, 기술주 중심의 나스닥지수는 163.95포인트(1.19%) 오른 13,950.22를 나타냈다. 다우지수와 S&P500지수와 나스닥지수는 모두 3거래일 만에 상승 전환에 성공했다.
        
        시장은 기업 실적과 바이든 정부의 추가 지출안, 코로나19 재확산 가능성 등을 주시했다. CNBC 분석에 따르면 지금까지 실적을 발표한 S&P500지수에 상장된 70개 이상의 기업들이 애널리스트들의 순익 예상치를 평균 23% 웃도는 실적을 발표했다. 최근 기업들이 예상치를 웃도는 실적을 발표하면서 이틀간 차익실현 매물에 주가는 하락세를 보였다. 하지만 이날 경기 민감주를 중심으로 주가는 다시 오름세를 보였다. 일각에서는 전 세계 코로나19 재확산에도 불구하고 미국의 코로나19 백신 접종률이 높아지면서 리플레이션 거래가 다시 돌아온 것이라고 주장했다. 또 주가가 이틀 연속 하락하면서 이를 저가 매수 기회로 삼으려는 투자자들도 투자에 나선 것으로 풀이된다.
        
        이날 주가 상승은 경제 재개에 수혜를 보는 경기순환주와 소형주 등이 상승을 주도했다. S&P500지수에 11개 섹터 중에서 에너지(1.48%), 소재(1.87%), 금융(1.39%), 산업(1.36%), 임의소비재(1.29%), 헬스(1.14%), 기술(1.02%) 관련주가 모두 1% 이상 올랐다. 경기 방어주인 유틸리티와 통신주는 각각 0.9%, 0.28% 떨어졌다. 
        
        바이든 행정부가 '미국 일자리 계획'으로 불리는 2조3천억 달러 규모의 인프라 구축 및 일자리 법안에 이어 1조 달러 규모의 초대형 지출안을 검토하고 있다는 소식도 나왔다. 워싱턴포스트(WP) 등에 따르면 바이든 대통령은 보육과 보편적 유치부 교육 등을 지원하는 1조 달러 규모의 '미국 가족 계획' 제안을 준비하고 있다.
        
        미국에서는 빠른 코로나19 접종으로 코로나 확산세가 다소 주춤해졌지만 인도와 일본 등 다수 국가에서 확진자 수가 다시 빠르게 증가하고 있다. 인도는 이중 변이 바이러스로 인해 신규 확진자 수가 연일 25만 명을 넘긴 가운데 이날 30만 명에 육박했다는 보도도 나왔다. 일본은 3개월 만에 신규 확진자가 5천 명대로 늘어 긴급 사태 결정을 검토하고 있다. 보건 당국자들도 기존 백신을 무력화하는 변이 바이러스의 출현 가능성을 지속해서 경고하고 있어 안심하긴 이른 상황이다.
        
        이날은 넷플릭스 주가가 7% 이상 크게 하락하면서 통신주의 약세를 이끌었다. 넷플릭스는 전날 장 마감 후 발표한 분기 실적에서 유료 구독자 수가 애널리스트들이 예상한 620만명을 크게 밑돈 398만명 순증에 그쳤다고 발표한 바 있다. 2분기 가입자 수도 100만 명 증가하는 데 그칠 것이라고 예상해 투자자들에게 실망감을 안겼다.
        
        크루즈선사인 노르웨이지안 크루즈는 골드만삭스가 투자 의견을 '중립'에서 '매수'로 상향하고, 목표가를 27달러에서 37달러로 올리면서 10% 이상 올랐다. 이에 따라 다른 크루즈선사인 카니발과 로열캐러비언도 각각 6%, 4% 이상 상승했다. 전날 8% 이상 떨어졌던 유나이티드항공 주가도 3%가량 반등했다. 
        
        뉴욕증시 전문가들은 최근의 주가 하락은 랠리에서의 건강한 조정이라며 주가가 오름세를 지속할 것으로 전망했다. 바클레이즈의 마이크 루이스 미 주식 거래 담당 대표는 월스트리트저널에 "시장이 계속 올라갈 것으로 보인다"라고 말했다. 캐피톨 증권의 켄트 엥겔케 수석 전략가는 CNBC에 "리플레이션 거래가 다시 왔다"라며 "하루는 상황이 갑자기 나빠지는 것 같더니, 다음날은 상황이 '와우'라고 외칠 만큼 좋아 보인다"고 말했다. 시카고상품거래소(CME) 페드워치에 따르면 연방기금(FF) 금리선물 시장은 9월 25bp 기준금리 인상 가능성을 11.3% 반영했다. 시카고옵션거래소(CBOE)에서 변동성지수(VIX)는 전장보다 1.18포인트(6.32%) 하락한 17.50을 기록했다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/366/2021/04/20/0000704623_001_20210514030218037.jpg",
        title: "[마켓뷰] 코스피, 3220선 돌파…3개월 만에 최고치 경신",
        date: '2021.04.20',
        description: `외국인 매수세에 3220 돌파 마감
        연초부터 상승률은 11.3%, G20 중 6위
        
        20일 코스피지수가 3220선에 올라서며 3개월여만에 종가 기준 사상 최고치를 기록했다. 
        외국인과 기관이 함께 매수하며 지수 상승을 이끌었다. 코스닥지수도 1030선을 돌파하며 연중 최고치를 경신했다.
        
        
        코스피지수는 전 거래일 대비 21.86포인트(0.68%) 오른 3220.70로 거래를 마쳐 3개월 만에 최고치를 경신했다.
        
        이날 코스피지수는 전 거래일 대비 21.86포인트(0.68%) 오른 3220.70으로 마감했다. 이는 종가 기준으로 사상 최고치다. 이전 최고치는 지난 1월 25일 기록한 3208.99였다. 약 3개월 만에 최고치를 경신한 셈이다. 장중 기준 역대 최고치는 지난 1월 11일에 기록한 3266.23이다. 이날 유가증권시장 시가총액도 사상 최대치인 2246조원을 기록했다. 지난 1월 25일보다 34조원이 늘었다.
        
        한국거래소에 따르면 이날까지 올해들어 코스피지수 상승률은 11.3%다. G20국가 중 한국보다 지수 상승률이 높은 곳은 사우디아라비아(16.2%), 남아프리카공화국(14.6%), 프랑스(13.4%), EU(13.2%), 독일(12.0%) 등 5개국이다. 거래소는 코스피지수가 사상 최고치를 기록한 이유로 ▲글로벌 경제회복에 대한 기대감 ▲시장 변동성 축소 ▲외국인 자금 유입 등을 꼽았다.
        
        간밤 미국 뉴욕 증시가 ‘숨 고르기’ 하락 마감한 영향으로 코스피지수는 이날 소폭 하락한 채 출발했다. 그러나 장 시작 후 9시 2분 3200선을 돌파하며 상승 전환한 이후 장 마감까지 상승세를 이어갔다.
        
        이날 코스피지수는 외국인과 기관이 이끌었다. 투자자별로 보면 외국인은 3258억원, 기관은 464억원을 순매수했다. 기관은 한때 순매도하는 모습을 보였지만 금융투자업종이 3004억원을 순매수하면서 매수세로 돌아섰다.
        
        개인은 오전 장중 ‘나홀로 매수’를 했다가 매도로 돌아섰다. 장 마감까지 3894억원을 순매도했다. 개인이 오는 5월 3일 공매도 재개 시점 전에 차익을 실현하기 위해 매도 물량을 내놓은 것이라는 시각도 있다. 이경민 대신증권 연구원은 "개인투자자들의 경우 공매도 재개를 경계하는 가운데 최근 단기 상승에 따른 차익매물이 출회되면서 3거래일 연속 순매도 했다"라고 말했다.
        
        코스피지수가 사상 최고치를 경신한 것은 1분기 실적이 개선될 것으로 기대되는 종목의 주가가 강세를 이어간 영향도 큰 것으로 분석된다. 이날 미래에셋증권은 화학, 철강, 정보기술(IT) 부품 등 실적 호전 기대가 높은 종목군이 계속해서 강세를 이어가고 있다는 점이 지수가 추가 상승할 가능성을 높이는 요소라고 밝혔다.
        
        유가증권시장에서 상한가를 기록한 종목은 흥국화재(000540)를 비롯한 7종목이었고 상승 종목은 664종목이었다. 보합은 67종목, 하락은 191종목이었으며 하한가를 기록한 종목은 없었다. 유가증권시장에 상장한 종목 70% 이상이 상승 마감한 셈이다.
        
        시가총액 상위 10개 종목 중에선 현대차(005380)(-0.43%)와 셀트리온(068270)(-3.07%)을 제외하고 모두 상승 마감했다. 삼성전자(005930)(0.72%)·SK하이닉스(000660)(0.36%)·NAVER(035420)(0.26%)·LG화학(051910)(1.36%)· 삼성바이오로직스(207940)(0.84%) 등이 모두 올랐다.
        
        금융업종도 강세를 보였다. 한국금융지주(071050)(5.77%)·한화손해보험(000370)(3.34%)·하나금융지주(086790)(3.30%) 등이 일제히 올랐다.
        
        이날 코스닥지수도 연중 최고치를 경신했다. 코스닥지수는 전 거래일 대비 2.42포인트(0.24%) 오른 1031.88로 마감했다. 지난 12일 ‘천스닥’에 올라선 코스닥지수는 7거래일째에 1030선에 안착했다. 개인은 1634억원을 순매수했으며 외국인과 기관은 각각 629억원, 705억원을 순매도했다.
        
        정명지 삼성증권 투자정보팀장은 "외국인들이 달러화 가치가 하락한 시점부터 매수세를 보였다"며 "달러화 약세가 오늘 코스피 지수 사상 최고치 돌파의 이유고 국내 기업들의 1분기 실적 기대감도 지수 상승에 힘을 보탰다"고 설명했다.
        `,
    },
    {
        src: "https://imgnews.pstatic.net/image/014/2021/04/15/0004620887_001_20210415075729528.jpg",
        title: "[원자재시황] 국제유가, 원유재고 급감·IEA 전망상향에 상승… WTI 4.9%↑",
        date: '2021.04.15',
        description: `[파이낸셜뉴스] 국제 유가는 코로나19 백신 확대와 경기 회복으로 원유 수요가 늘어날 것이라는 기대에 크게 올랐다. 

        14일(현지시간) 뉴욕상업거래소에서 5월물 서부텍사스산원유(WTI) 가격은 전장보다 2.97달러(4.9%) 오른 배럴당 63.15달러에 마감했다. 
        
        런던ICE선물거래소에서 6월물 브렌트유 가격 역시 전장보다 2.9달러 오른 배럴당 66.58달러로 장을 마쳤다. 
        
        이날 유가는 3월 17일 이후 최고치를 경신했다. 
        
        유가는 국제에너지기구(IEA)가 전 세계 원유 수요가 회복세를 보인다며 올해 글로벌 원유 수요 전망치를 상향한 영향으로 오름세를 보였다. 
        
        IEA는 월간 보고서에서 2021년 글로벌 원유 수요가 전년보다 하루 570만 배럴 늘어날 것으로 예상했다. 이는 이전 전망치보다 하루 23만배럴 증가한 것이다. 
        
        IEA는 전년보다 올해 원유 수요는 570만 배럴 늘어난 9670만 배럴에 달할 것으로 추정했다. 
        
        지난주 석유수출국기구(OPEC)도 올해 글로벌 원유 수요 전망치를 이전보다 하루 10만 배럴가량 상향한 바 있다. 
        
        OPEC은 글로벌 원유 수요가 하루 600만 배럴가량 늘어난 9650만 배럴에 이를 것으로 전망하고, 전 세계 성장률 전망치도 기존 5.1%에서 5.4%로 상향했다. 
        
        프라이스 퓨처스 그룹의 필 플린 선임 시장 애널리스트는 "통상 비관적이었던 IEA가 매우 강한 강세를 예상하면서 유가가 한 달간 지속된 박스권을 벗어나려고 하고 있다"고 말했다. 
        
        원유재고가 예상보다 더 크게 줄어든 점도 유가 상승에 힘을 보탰다. 
        
        미국 에너지정보청(EIA)은 지난 9일로 끝난 한 주간 원유 재고가 589만 배럴 줄어든 4억9242만3000배럴로 집계됐다고 발표했다. 
        
        월스트리트저널(WSJ)이 집계한 애널리스트 예상치 250만 배럴 감소보다 더 큰 폭의 감소세다. 휘발유 재고가 30만 배럴 늘었으며 정제유 재고는 210만 배럴 감소했다. 
        
        한편 국제 금값은 하락했다. 
        
        이날 뉴욕상품거래소에서 4월물 금 가격은 전날보다 11.30달러(0.7%) 하락한 1736.30달러에 마감했다. 최근 지속된 하락세를 보인 미국 10년물 국채수익률이 이날 소폭 상승하면서 금값에 하락 압력으로 작용했다. `,
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/04/13/0004900801_001_20210413161242917.jpg",
        title: "[코스닥 마감]개미 덕에 천스닥 굳히기…1010선까지 상승",
        date: '2021.04.13',
        description: `외국인, 기관 '팔자'…대부분 업종 상승 가운데, '유통' 강세
        시총 상위株, 대부분 상승…셀트리온 형제株 5% 안팎↑
        거래대금 14조원대 기록해 전날 11조원대 대비 급증
        [이데일리 고준혁 기자] 13일 코스닥이 상승 마감했다. 개인 투자자 매수에 힘입어 상승세를 유지했다. 전 거래일 대비 거래량이 크게 늘었다. 전날 20년 만에 1000선을 돌파한 뒤 추종 매수세가 유입된 것으로 풀이된다.
        
        한국거래소에 따르면 이날 코스닥은 전 거래일 대비 9.72포인트(0.97%) 오른 1010.37에 마감했다. 개인이 적극적으로 매수에 참여했고 바이오 업종 중심으로 상승했다. 
        
        간밤 뉴욕 증시는 소폭 하락했다. 뉴욕증권거래소(NYSE)에서 다우존스 30 산업평균지수는 전장보다 55.20포인트(0.16%) 하락한 3만3745.40으로 마감했다. 스탠더드앤드푸어스(S&P)500 지수는 0.81포인트(0.02%) 떨어진 4127.99로 장을 마쳤다. 나스닥지수는 50.19포인트(0.36%) 하락한 1만3850.00에 마감했다.
        
        사장은 미국 3월 소비자물가지수(CPI) 발표를 앞두고 이에 촉각을 곤두세운 것으로 풀이된다. 이날 발표되는 CPI지수가 예상보다 양호하다면 또 다시 긴축 우려가 나타날 가능성이 있다.
        
        수급별로는 개인이 531억원 순매수했다. 외국인과 기관이 각각 257억원 112억원 순매도했다. 프로그램별로는 차익이 20억원, 비차익이 525억원 각각 순매도을 기록, 전체 545억원 순매도로 마감했다. 
        
        업종별로는 유통이 3% 상승 마감해 강세를 보였다. 이어 정보기기, 제약, 운송, 의료·정밀기기, 종이·목재, 기계·장비, 제조, 기타서비스, 디지털컨텐츠, 통신장비, 화학, IT S/W·SVC, 방송서비스, 소프트웨어, 일반전기전자, IT종합 등이 상승 마감했다. 반면 금융과 건설, 기타제조, 섬유·의류, 오락·문화, 출판·매체복제 등은 하락 마감했다. 
        
        시가총액 상위주는 대부분 상승했다. 대장주인 셀트리온헬스케어(091990)는 4.54% 상승 마감했다. 셀트리온제약(068760)도 5.55% 상승했다. 씨젠(096530), 카카오게임즈(293490), 에코프로비엠(247540), 에이치엘비(028300), SK머티리얼즈(036490), CJ ENM(035760) 등도 상승 마감했따. 알테오젠(196170)은 하락 마감했다. 펄어비스(263750)는 보합권에 머물렀다. 
        
        이날 거래량은 36억635만주를 기록했다. 전 거래일 19억1015만주 대비 크게 증가했다. 거래대금 기준으로는 14조3128억원을 기록했다. 전 거래일은 11조9403억원으로 마감했다. 
        
        상한가 6개 포함 705개 종목이 올랐고 하한가 없이 596개 종목이 내렸다. 99개 종목은 보합권에 머물렀다.
        `,
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/04/06/0004894566_001_20210406160255407.jpg",
        title: "[외환마감]한달여만에 1190원대 하락..미 국채 금리 1.6% 내려",
        date: '2021.04.06',
        description: `미 국채 10년물 금리 상승 진정세에 위험선호 회복
        코스피 상승, 위안화 강세도 달러 상대적 약세 영향
        
        사진=AP 연합뉴스
        [이데일리 이윤화 기자] 원·달러 환율이 8원 가량 하락해 약 한달 여만에 1120원 아래로 내렸다. 원·달러 환율이 종가 기준 1120원 아래로 떨어진 것은 지난 2월 25일(1107.8원) 이후 33거래일만이다. 미국 경제 지표 호조가 뉴욕증시 상승, 위험선호 재개로 이어졌고 코스피도 상승 마감했다. 
        
        
        6일 원달러 환율 변동 추이.
        6일 서울외국환중개에 따르면 원·달러 환율은 전 거래일보다 8.1원(0.72%) 하락한 1119.6원에 장을 마쳤다. 이날 환율은 이날 환율은 전 거래일보다 3.2원(0.28%) 내린 1124.5원에 출발해 오후 들어 하락폭을 키웠다. 오후 3시 20분께는 1120원 아래로 떨어졌다. 
        
        1.7% 중반대를 웃돌던 미 국채 10년물 금리는 1.6%대로 내렸다. 현지시간 이날 오전 2시 반께 미국 국채 10년물 금리는 전장 대비 0.027%포인트 내린 연 1.693%를 기록하고 있다. 주요 6개국 통화 대비 달러의 가치를 나타내는 달러인덱스도 전장 대비 93포인트대에서 92포인트 중반대로 내렸다. 달러·위안 환율은 전일 대비 0.05% 하락한 6.5545를 나타내고 있다. 
        
        뉴욕지수 선물은 하락세를 보이고 있다. 다우지수 선물은 전 거래일 대비 0.19% 내린 3만3352를 나타내고 있다. 스탠더드 앤드 푸어스(S&P) 500 지수 선물은 0.18% 내린 4060.50에, 나스닥 100 선물은 0.10% 하락한 1만3572에 거래되고 있다. 
        
        국내 증시는 외국인과 개인의 매수세에 4거래일째 상승 마감했다. 이날 코스피 지수는 전 거래일보다 6.25포인트(0.20%) 오른 3127.08에 장을 마쳤다. 외국인은 5747억원을 순매수 했다. 기관과 개인은 각각 5145억원, 315억원 가량 매도했다. 
        
        이날 서울외국환중개와 한국자금중개에서 거래된 자금은 92억2600만달러다.`,
    },
    {
        src: "https://imgnews.pstatic.net/image/008/2021/04/02/0004566967_001_20210402085003195.jpg",
        title: `증권가가 꼽은 美부양책 수혜주…"법인세 상쇄할 실적이 중요"`,
        date: '2021.04.02',
        description: `[머니투데이 김태현 기자] [[개장전]]


        [피츠버그=AP/뉴시스]조 바이든 미국 대통령이 3월 31일(현지시간) 미 펜실베이니아주 피츠버그의 카펜터스 트레이닝 센터에서 인프라 투자 등에 관해 연설하고 있다. 바이든 대통령은 총 2조2500억 달러(약 2548조5700억 원) 규모의 8년 장기 인프라·일자리 투자 법안인 '미국 일자리 계획'을 발표했다. 2021.04.01.
        
        미국 뉴욕증시에서 S&P(스탠다드앤(스탠다드앤푸어스)500지수가 사상 처음 4000포인트를 넘겼다. 조 바이든 대통령의 2조달러(약 2263조원) 규모의 경기부양책이 호재다.
        
        증권업계 전문가들은 부양책 수혜가 기대되는 종목에 집중해야 한다고 강조했다. 단 이번 부양책이 법인세 인상을 동반한 만큼 이를 상쇄할만한 실적이 중요하다고 설명했다.
        
        1일(현지시간) 뉴욕증시에서 다우지수는 전일대비 171.66포인트(0.52%) 오른 3만3153.21, S&P500지수는 이날 46.98포인트(1.18%) 오른 4019.87로 장을 마쳤다. 사상 처음 4000선을 넘었다. 나스닥 종합지수는 233.23포인트(1.76%) 오른 1만3480.11로 거래를 마쳤다.
        
        대규모 경기부양책에 대한 기대가 투자심리를 개선시킨 덕분이다. 바이든 대통령은 지난달 31일 펜실베이니아주 피츠버그 연설에서 도로, 다리, 5G(5세대) 통신망 등 기반시설에 2조달러 이상을 투자하는 '미국 일자리 계획'(American Jobs Plan)을 발표했다. 
        
        직접적인 수혜가 기대되는 인프라 관련 종목을 비롯해 그동안 금리 상승 부담에 지지부진한 모습을 보였던 페이스북과 애플 등도 1% 전후의 오름세를 보였다.
        
        10년 만기 미국 국채 금리도 하락했다. 바이든 대통령이 법인세 증세를 통해 부양책 재원을 마련하겠다는 소식에 국채 수급 부담을 덜었다. 또 이날 발표된 3월 PMI(구매관리자지수) 역시 64.7로 1983년 12월 이후 최고치를 기록하면서 경기 회복에 대한 기대감을 키우고 있다.
        
        김대준 한국투자증권 연구원은 "코스피는 3040~3140포인트 내에서 완만한 상승세를 보일 전망"이라며 "양호한 경제지표가 지수레벨을 지지할 것"이라고 내다봤다.
        
        업종별로는 부양책 수혜가 기대되는 반도체, 자동차, 2차전지, 신재생에너지 업종의 주가 흐름이 기대된다. 최유준 신한금융투자 연구원은 "이번 부양책에 반도체 산업에 대한 500억달러 규모 지원책이 포함되면서 중요성이 부각됐고, 미국 내 설비투자 확대가 추진될 계획"이라고 설명했다.
        
        아관울러 바이든 정부는 차량 교체와 충전 인프라 확대 등 전기차 보급 확대를 위해 1740억달러를 투자할 계획이다. 신재생에너지와 련해서는 2035년 탄소 제로를 달성할 계획이다.
        
        법인세 인상을 상쇄할만한 실적도 중요하다. 한대훈 SK증권 연구원은 "세금인상은 분명 달갑지 않은 소식"이라며 "정책적인 지원으로 인해 법인세 인상을 상쇄할 수 있는 업종의 매력이 높아질 시기"라고 설명했다. 향후 1년간 실적개선 기대감이 높은 업종에 주목해야 한다고 강조했다.
        
        `,
    },
    {
        src: "https://imgnews.pstatic.net/image/011/2021/03/26/0003888426_001_20210326092035166.jpeg",
        title: "[오전시황]코스피 0.4% 소폭 올라 3,020선...外人 순매수",
        date: '2021.03.26',
        description: `[서울경제] 

        미국 3대 지수가 모두 상승 마무리한 가운데 외국인 투자자가 유입되면서 코스피가 3,000선 중반대로 진입을 시도하고 있다.
        
        26일 오전 9시 15분 기준 코스피지수는 전일 대비 13.07포인트(0.43%) 증가한 3,021.40을 가리키고 있다. 이날 코스피는 4.46포인트(0.15%) 증가한 3,012.79에 출발했다.
        
        같은 시각 유가증권시장에 외국인은 326억 원 순매수 중이다. 개인과 기관은 각각 7억 원, 253억 원을 팔았다.
        
        간밤 미국증시는 상승세로 마감했다. 다우존스산업평균지수는 전일보다 199.42포인트(0.62%) 오른 3만 2,619.48에 마감했다. 스탠더드앤드푸어스(S&P)500은 20.38포인트(0.52%) 상승한 3,909.52, 나스닥은 15.79포인트(0.12%) 오른 1만 2,977.68에 거래를 끝냈다. 
        
        이날 제롬 파월 연방준비제도(Fed·연준) 의장이 페이퍼링의 가능성을 시사하는 듯한 발언을 꺼내면서 시장은 잠시 긴장했지만, 경제 재개 기대가 다시 커지면서 재차 강세를 보였다. 파월 의장은 “정책 목표에 명확한 진전이 있으면 우리가 사들인 국채와 모기지담보 증권 규모를 줄여 나갈 것”이라며 “우리는 오랜 시간에 걸쳐서 매우 점진적으로 투명성을 갖고 이를 할 것”이라고 말했다.
        
        서정훈 삼성증권 연구원은 “파월 의장의 인터뷰가 미국 장 초반 증시를 압박했지만 기존 입장과 다름이 없음을 투자자들이 인식하면서 상승세로 돌아섰다”며 “신규 실업수당 신청 건수가 68만 4,000건으로 코로나19 팬데믹 이후 처음으로 70만 건을 하회하면서 개선된 고용환경을 보여주는 지표도 나왔다”고 설명했다. 그러면서 “올해 외국인 투자자는 유가증권시장에서 9조 원에 달하는 매물을 출회시켰지만 금융, 철강·금속, 화학 등 경기민감주에서는 두드러진 매수세가 확인됐다"며 “경기 여건을 고려하면 이들 업종에 대한 선호 심리는 더욱 확산될 전망”이라고 분석했다.
        
        같은 시각 코스닥지수는 전일 대비 0.80포인트(0.08%) 상승한 9552.79를 가리키고 있다. 이날 코스닥은 0.69포인트(0.07%) 증가한 955.68 에 출발했다. 코스닥시장에서는 개인이 홀로 546억 원을 순매수 중이다. 외국인과 기관은 391억 원, 155억 원을 순매도 중이다.
        `,
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/03/22/0004881726_001_20210322154506812.jpg",
        title: "[외환마감]美 10년물 금리 하락에 환율, 하루 만에 1120원대",
        date: '2021.03.22',
        description: `미 10년물 금리 1.6%대로 하락
        외국인, 코스피서 5500억원 매도세
        [이데일리 최정희 기자] 원·달러 환율이 하루 만에 1120원대로 하락했다. 미국 10년물 국채 금리가 1.6%대로 떨어진 영향이다. 
        
        
        (사진= AFP)
        22일 서울외국환중개에 따르면 이날 원·달러 환율은 전 거래일보다 2.20원 하락한 1128.40원에 거래를 마쳤다. 환율은 뉴욕차액결제선물환(NDF) 시장에서 거래된 원·달러 1개월물 추이를 따라 전 거래일 종가보다 소폭 상승한 1131.00원에 개장한 이후 1133.60원까지 오르는 듯 했으나 장중 내내 상승폭을 줄이고 오후 들어선 하락세로 전환됐다. 
        
        이날 환율이 하락세로 전환한 것은 미국 10년물 국채 금리가 1.6%대로 하락한 영향으로 풀이된다. 10년물 국채 금리는 지난 19일(현지시간) 미국 연방준비제도(Fed·연준)가 은행권에 적용됐던 보완적 레버리지 비율(SLR·supplementary leverage ratio) 완화 조치를 연장하지 않기로 하면서 1.74%대까지 올랐으나 이날 다시 하락했다. 22일(현지시간) 새벽 2시 30분께 10년물 국채 금리는 1.675%를 기록, 소폭 하락세를 보였다. 
        
        은행은 자기자본을 보유 자산의 3~5% 확충해야 하는데 국채와 연준 지급준비금을 익스포저에서 제외토록 해 자본금 확충 필요 없이 국채를 더 많이 보유하고 시중에 더 많은 대출을 해주도록 했으나 이 조치를 연장하지 않은 것이다. 이럴 경우 은행은 보유하던 국채를 매도할 가능성이 높다. 시장에선 3500억~5000억달러의 매도 물량이 출회할 것으로 예측했다. 일각에선 SLR 종료 이슈가 미리 시장에 반영된데다 12개 은행밖에 적용을 받지 않아 시장에 미치는 영향이 제한적이란 분석이 나온다. 
        
        국채 금리가 하락한데다 달러·위안 환율은 6.5위안대에서 강보합권을 유지했다. 위험자산 회피 심리가 일부 누그러지면서 환율은 중공업체의 수출 네고 물량 등에 힘입어 오후 들어선 하락세로 전환한 것으로 풀이된다. 다만 코스피 지수는 외국인 투자자의 5500억원 규모의 매도세에 전 거래일보다 4.07포인트, 0.13% 하락한 3035.46에 거래를 마쳤다. 
        
        서울외국환중개와 한국자금중개의 합산 거래규모는 78억9400만달러로 집계됐다.
        `
    },
    {
        src: "https://imgnews.pstatic.net/image/003/2021/03/18/NISI20180907_0000198272_web_20180907111214_20210318160330725.jpg",
        title: "[마감시황]코스피, FOMC 안도감에 상승…3060선 회복",
        date: '2021.03.18',
        description: `네이버, 5% 넘게 오르며 40만원 돌파

        [서울=뉴시스] 류병화 기자 = 코스피가 미국 연방공개시장위원회(FOMC) 회의 결과에 안도하며 상승 마감했다. 지수는 0.6% 올라 3060선을 회복했다.
        
        18일 코스피는 전 거래일(3047.50)보다 18.51포인트(0.61%) 오른 3066.01에 마감했다. 지수는 전일 대비 0.24% 오른 3054.93에 출발해 장중 1.4% 상승하는 등 강세를 보였으나 마감 전 상승폭을 일부 내주며 거래를 마쳤다.
        
        유가증권시장에서 외국인과 기관은 각각 4868억원, 1375억원어치를 사들였다. 반면 개인은 홀로 6202억원을 순매도했다.
        
        업종별로는 대부분 올랐다. 서비스업(1.93%), 종이목재(1.54%), 운수장비(1.53%), 운수창고(1.07%), 증권(0.86%), 전기전자(0.85%) 등의 상승폭이 컸다.
        
        시가총액 상위 종목들은 셀트리온(-0.51%)을 제외하고 일제히 올랐다. 대장주 삼성전자는 전 거래일 대비 600원(0.73%) 오른 8만2900원에 거래를 마쳤다. 이어 SK하이닉스(1.43%), LG화학(0.47%), 현대차(0.86%), 삼성바이오로직스(0.42%), 삼성SDI(3.60%), 카카오(2.68%) 등이 올랐다.
        
        네이버는 쇼핑 부문 재평가에 힘입어 5% 넘게 상승하며 40만원을 돌파했다. 네이버는 이날 전일 대비 5.22% 오른 40만3500원에 마감했다. 장중 41만원까지 치솟으며 52주 신고가를 기록했다.
        
        네이버는 전일 열린 '애널리스트 데이'에서 ▲판매자 솔루션 강화 ▲다양한 구매방식 지원 ▲멤버십으로 파트너십 생태계 확대 ▲데이터기반 온디맨드 풀필먼트 구축 ▲글로벌 진출 등 커머스 성장을 위한 전략방향 5가지를 공개했다.
        
        간밤 미국 뉴욕 증시는 미국 연방준비제도(Fed·연준)의 비둘기파적 기조 유지에 강세를 보였다.
        
        CNBC와 마켓워치에 따르면 17일(현지시간) 뉴욕증권거래소(NYSE)에서 다우존스30산업평균지수는 전장 대비 189.42 포인트(0.58%) 오른 3만3015.37에 장을 마쳤다.
        
        스탠더드앤드푸어스(S&P)500지수도 전장보다 11.41 포인트(0.29%) 상승해 3974.12에 장을 마쳤다. 다우지수와 S&P500지수는 사상 최고치를 찍었다. 기술주 중심의 나스닥 지수는 53.64 포인트(0.40%) 상승해 1만3525.20에 마감했다.
        
        연준은 이날 FOMC 회의 후 성명을 통해 기준금리를 제로에 가까운 수준으로 유지한다고 밝혔다. 아울러 2023년까지 제로금리가 유지될 것이라고 전망했다.
        
        이경민 대신증권 연구원은 "이번 달 FOMC가 글로벌 금융시장에 서프라이즈 모멘텀을 제공하진 않았지만 적어도 글로벌 자산 인플레이션을 지속할 환경을 제공했다"며 "코스피는 2분기 이후 물가와 금리 상승을 압도하는 경제성장률, 기업이익 모멘텀에 상승 추세를 재개할 전망"이라고 전했다.
        
        코스닥지수는 전 거래일(943.78)보다 6.05포인트(0.64%) 오른 949.83에 마감했다. 지수는 전일 대비 0.14% 오른 945.11에 출발해 상승폭을 늘리며 거래를 마쳤다.
        
        코스닥시장에서 기관은 홀로 529억원어치를 사들이며 지수 상승을 이끌었다. 반면 개인과 외국인은 391억원, 15억원을 순매도했다.
        
        코스닥 시총 상위 10개 종목은 엇갈렸다. 셀트리온헬스케어(-0.16%), 셀트리온제약(-0.07%), 펄어비스(-1.53%), 씨젠(-0.07%), SK머티리얼즈(-1.17%), 스튜디오드래곤(-0.83%) 등이 하락했다. 반면카카오게임즈(1.36%), 에코프로비엠(0.51%), CJ ENM(0.77%) 등은 올랐으며 알테오젠은 보합 마감했다.
        
        `
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/03/16/0004877110_001_20210316154854597.jpg",
        title: "[코스닥 마감]외인·기관 순매수에 1% 넘게 상승…'940선'",
        date: '2021.03.16',
        description: `4거래일 연속 오름세 유지, 940선 위로
        시총상위株 강세, 업종 전반 강세
        [이데일리 권효중 기자] 16일 코스닥 지수가 외국인과 기관의 동반 순매수로 1% 넘게 오르며 940선에 안착했다. 
        
        
        (자료=신한금융투자 HTS)
        마켓포인트에 따르면 이날 코스닥 지수는 전 거래일 대비 1.48%(13.75포인트) 오른 940.65로 거래를 마쳤다. 코스닥 지수는 미국발 국채 금리가 국내 시장에도 변수로 작용하며 지난주 한때 900선을 하회하기도 했지만, 지난 11일 900선을 회복한 이후 4거래일째 오름세를 이어오며 940선까지 회복했다. 간밤 미국 국채 금리는 1.6% 수준으로 다소 안정적인 모습으로 접어들었다. 
        
        수급별로는 개인이 홀로 464억원을 팔았다. 외국인은 450억원, 기관은 822억원 어치를 각각 사들였다. 프로그램 매매는 차익이 198억원, 비차익이 610억원 순매수로 총 808억원 순매수로 집계됐다. 
        
        업종별로는 일반전기전자(-0.40%), 운송(-1.68%), 기타제조(-2.75%)를 제외한 전 업종이 올랐다. 반도체와 통신서비스가 3% 넘게 올랐고, 유통과 제약, 오락문화, 통신방송서비스, 통신장비 등은 2% 넘게 올랐다. 소프트웨어, 의료정밀기기, 기타서비스, 섬유의류 등이 1%대 올랐으며 비금속, 건설, 출판·매체복제 등도 1%대 미만에서 올랐다. 
        
        시가총액 상위 종목들도 대부분 강세를 보였다. 셀트리온헬스케어(091990)가 3.48%, 셀트리온제약(068760)이 2.97% 올라 나란히 강세를 보였으며, 알테오젠(196170)(1.05%), 펄어비스(263750)(2.49%), 카카오게임즈(293490)(0.99%), 씨젠(096530)(0.69%), SK머티리얼즈(036490)(1.03%), CJ ENM(035760)(1.19%) 등 바이오와 콘텐츠 등 업종과 관계없이 오름세를 보였다. 반면 에코프로비엠(247540)은 3.76%, 제넥신(095700)은 4.58%씩 약세를 보였다. 
        
        종목별로는 갤럭시아머니트리(094480)가 이날 생활금융플랫폼 ‘머니트리’의 월 충전액 100억원을 돌파했다는 소식에 16.90% 올랐다. 메가스터디교육(215200)은 코로나19 이후 온라인 교육 수요 증가로 올해 사상 최대 실적을 기대할 수 있다는 증권가 분석에 8.65% 올라 거래를 마쳤다. 
        
        한편 이날 거래량은 33억2095만9000주, 거래대금은 12조5797억5100만원으로 각각 집계됐다. 상한가 종목 3개를 포함해 871개 종목이 올랐고, 하한가 1개를 포함해 446개 종목이 내렸다. 보합권에 머문 종목은 91개였다.`
    },
    {
        src: "https://imgnews.pstatic.net/image/014/2021/03/16/0004601540_001_20210316072626553.jpg",
        title: "[원자재시황] 급등 부담에 유가 하락 WTI 0.3%↓..금값은 0.6%↑",
        date: '2021.03.16',
        description: `[파이낸셜뉴스] 국제 유가는 15일(현지시간) 중국의 원유 수요가 양호할 것이란 기대에도 높은 가격에 대한 부담이 이어지면서 하락했다. 

        이날 뉴욕상업거래소에서 4월물 서부 텍사스산 원유(WTI) 가격은 배럴당 0.22달러(0.3%) 하락한 65.39달러에 장을 마감했다. 
        
        5월물 브렌트유 가격 역시 0.5% 하락한 68.88을 기록했다. 
        
        에드워드 모야 오안다 애널리스트는 "코로나19 케이스가 뉴저지와 미시간에서 증가하고 있으며 이같은 트렌드가 전국적으로 확산된다면 재개 조치가 일부 지연될 수 있을 것"이라며 "백신접종이 잘 진행되고 있지만 단기 리스크는 여전하다"고 말했다. 
        
        시장 참가자들은 중국과 미국 등 주요국 경제 지표와 원유 수요 전망 등을 주시하고 있다. 
        
        세계 최대 원유 수입국 중국의 산업 관련 지표가 양호하게 나오는 등 올해 수요 회복에 대한 기대가 이어졌다. 
        
        지난 1~2월 중국 산업생산은 전년 동기 대비 35.1% 증가했다. 월스트리트저널이 집계한 시장 예상치인 30.5% 증가를 넘어섰다. 산업 활동 회복세가 지속하는 만큼 원유에 대한 수요도 탄탄할 것이란 기대가 형성됐다. 
        
        미국의 수요 회복 기대도 큰 상황이다. 미 정부는 1조9000억 규모 초대형 경기 부양에 돌입했다. 
        
        뉴욕 연방준비은행의 3월 엠파이어스테이트 지수 지난해 여름 이후 가장 높은 수준으로 오르는 등 경제 지표도 양호한 흐름을 이어가고 있다. 
        
        하지만 유가가 브렌트유 기준으로 배럴당 70달러 등 주요 레벨 부근까지 오른 데 따른 부담도 적지 않다. 
        
        OPEC+(석유수출국기구 및 러시아 등 주요 산유국 모임)이 4월 산유량도 거의 동결했지만, 유가가 이 정도로 높은 수준을 유지하면 언제든 증산이 단행될 수 있다는 경계심도 여전하다. 
        
        미국 등 OPEC+외 등 다른 산유국의 생산량이 늘어날 것이란 전망도 제기된다. 
        
        유럽지역에서 신종 코로나바이러스 감염증(코로나19) 확산세가 여전히 강한 점도 부담이다. 
        
        독일과 프랑스 등 유럽 다수의 국가는 아스트라제네카 백신의 접종을 일시 중단키로 하는 등 백신 관련 혼선도 이어지는 중이다. 
        
        전문가들은 레벨 부담으로 상승세가 주춤해지긴 했지만, 수요 전망 개선으로 유가가 지지력을 유지할 수 있을 것으로 내다봤다. 
        
        SEB의 비야른 시드로프 원자재 담당 연구원은 "미국의 코로나19로 인한 사망자의 감소와 중국의 명백한 수요 반등에 힘입어 글로벌 원유 수요가 회복될 것이란 자신감이 커지고 있다"고 말했다. 
        
        한편 금값은 미국 국채 금리가 반락하고 달러 강세도 주춤해지면서 상승했다. 
        
        이날 뉴욕상품거래소에서 4월물 금값은 전 거래일보다 0.6% 상승한 1729.20달러에 마감했다. 최근 2주래 최고 상승폭이다.
        
        미 국채 10년물 금리가 1.6%대 초반으로 소폭 반락하고 달러 강세에 대한 부담이 줄어들면서 금값을 밀어올렸다. `
    },
    {
        src: "https://imgnews.pstatic.net/image/018/2021/03/15/0004876034_001_20210315155220104.jpg",
        title: `[외환마감]환율, 1130원대 상승.."위험회피, 코스피도 하락"`,
        date: '2021.03.15',
        description: `미국채 10년물 금리 1.6% 상승
        코스피 3040선으로 하락 마감
        
        사진=AFP
        [이데일리 이윤화 기자] 원·달러 환율이 2.5원 올라 사흘 만에 상승 마감했다. 미 국채 금리가 연 1.6%대로 뛰어 올라 위험선호 심리가 약해진 영향이다. 국내 증시도 외국인과 기관의 동시 매도세에 하락 마감했다. 
        
        
        15일 원달러 환율 추이
        15일 서울외국환중개에 따르면 원·달러 환율은 전 거래일보다 2.5원(0.22%) 오른 1136.3원에 거래를 마쳤다. 이날 환율은 전 거래일 대비 2.7원 오른 1136.5원에 개장한 이후 장중 1138.3원까지 오르기도 했지만 장 후반 이월 네고 물량(달러 매도)이 몰리며 상승폭을 좁혔다.
        
        14일(현지시간) 오전 1시 40분께 미국 국채 10년물 금리는 전장 대비 0.001%포인트 내린 연 1.634%를 기록하고 있다. 주요 6개국 통화 대비 달러의 가치를 나타내는 달러인덱스도 91선에서 등락하는 중이다. 
        
        뉴욕지수 선물은 혼조세를 보이고 있다. 다우지수 선물은 전 거래일 대비 0.16% 오른 3만2718를 나타내고 있다. 스탠더드 앤드 푸어스(S&P) 500 지수 선물은 0.03% 오른 3934.25에, 나스닥 100 선물은 0.06% 빠진 1만2917.75에 거래되고 있다.
        
        국내증시도 장 초반 상승 흐름을 되돌려 하락 마감했다. 코스피 지수는 전일 대비 8.68포인트(0.28%) 내린 3045.71에 거래를 마쳤다. 외국인이 2147억원, 기관이 3161억원 가량 매도 했다. 개인은 5224억원 가량 순매수했다. 
        
        이날 서울외국환중개와 한국자금중개에서 거래된 자금은 77억700만달러다.
        `
    },
    {
        src: "https://imgnews.pstatic.net/image/215/2021/03/12/A202103120104_1_20210312174555667.jpg",
        title: "다시 고개드는 위기설…인플레 공포 `엄습` [증시전망대]",
        date: '2021.03.12',
        description: `증시전망대 시간입니다. 증권부 정경준 기자 나와 있습니다. 다음주 주요 일정 먼저 살펴볼까요? 우리시간으로 18일 새벽 미국의 FOMC 회의 결과가 나옵니다.

        <기자>
        
        
        
        
        미국 국채 금리 움직임에 따라 국내·외 주식시장이 크게 등락을 거듭하고 있습니다. 금리에 대한 민감도가 높은 상황인데 우리시간으로 18일 새벽 미 FOMC 회의 결과가 나옵니다. FOMC 회의를 기점으로 금리를 둘러싼 시장의 불안심리가 진정될지가 관건입니다. 중국의 2월 산업생산, 그리고 미국의 수출입물가와 소매판매 등 실물경기지표도 주목 대상입니다. 18일에는 SK바이오사이언스가 코스피시장에 상장합니다. 사상 최대 규모인 64조에 달하는 청약증거금이 몰렸는데 상장 이후 어떤 주가 흐름을 보일지 관심입니다.
        
        <앵커>
        
        미 FOMC 회의 얘기부터 해보죠, 시장금리 문제, 인플레이션 등과 관련해 연준의 구체적인 언급 여부 등에 시장의 촉각이 곤두서 있습니다. 어떻게 전망되고 있습니까?
        
        <기자>
        
        일단 달라진 시장 상황 두 가지가 있습니다. 미국의 1조9천억 달러 규모의 부양법안이 바로 시행에 들어갑니다. 미국 국민 1인당 최고 1천400달러의 현금이 지급되고 주당 300달러 실업급여가 9월까지 연장돼 지급됩니다. 또 하나는 유럽중앙은행이 최근 국채금리 급등과 관련해 채권매입 속도를 높이기로 했습니다. 총량에는 변화없이 채권 매입 규모를 일시적으로 늘리겠다는 겁니다. 그러면서 올해 물가상승률 전망치를 기존 1.0%(지난해 12월)에서 1.5%로 크게 올렸습니다. 미 연준 입장에서는 고민이 되는 대목입니다. 당장의 관심은 연준의 향후 경기전망입니다. 부양책이 시행에 들어가는 만큼 향후 성장률 전망치의 상향 조정이 예상되는데 이와 맞물려 연준의 기존 고용과 물가 목표의 변화, 특히 앞으로의 물가 경로에 대한 연준의 전망에 우선적으로 관심이 집중되고 있습니다. 강한 경기회복이 전망될 경우 경제정상화에 따른 연준의 조기 긴축 등의 우려감이 시장에선 재차 부각될 가능성도 적지 않습니다. 일단 시장에선 완화적 통화정책의 기존 입장을 재확인하면서 뭔가 내놓지 않을까하는 기대감이 있는게 사실입니다. 추가적으로 채권 매입 확대나 단기물 채권을 팔고 장기물 채권을 사는 오퍼레이션 트위스트(OT), 그리고 코로나19 팬데믹 대응 차원에서 이뤄졌던 은행 등 금융기관의 SLR(보완적 레버리지 비율) 완화 연장 여부 등에 대한 조심스런 관측도 나옵니다.
        
        <앵커>
        
        시장에선 또다시 위기설이 나도는 것 같던데, 4~6월을 분수령으로 보는 것 같습니다.
        
        <기자>
        
        기저효과가 본격적으로 반영되는 시점이기 때문에 그런 우려감들이 나오는 것으로 보입니다. 지난해 이 시기는 팬데믹 직후로 경제활동 자체가 봉쇄되고 국제유가도 사상 처음 마이너스까지 떨어졌던 시기였습니다. 이제 경제가 재개되고 백신 접종이 본격화되면서 수치상으로 인플레이션 압력이 커질 수 밖에 없는 상황입니다. 아울러 최근의 국채 금리 급등의 원인으로 경기회복 기대 외에도 확장적 재정정책에 따른 물량 급증 요인이 더 큰 영향을 미치고 있다는 분석들이 있는데 이런 관점에서 봤을 때 1조9천억 달러 규모의 부양책의 물량 부담이 본격화할 시점이라는 점에서 경계심을 키우고 있습니다. 바이든 행정부는 이 외에도 현재 추가로 3조달러 규모의 대규모 인프라 부양책을 예고한 상황입니다. 이런 상황을 감안할 때 4~6월중 임계점을 맞지 않을까하는 조심스런 관측도 시장 일각에선 나옵니다.
        
        <앵커>
        
        우리나라 3년물 국채 금리 움직임도 최근 심상치 않습니다. 이달 들어 크게 튀어오르고 있는데요, 가계부채 문제와 맞물려 금융시장에도 적잖은 영향을 우려됩니다.
        
        <기자>
        
        
        
        
        지난 9일 기준으로 국고채 3년물 금리는 연 1.21%에 달하고 있습니다. 이달 들어 가파른 상승세를 보이고 있는데 장기물에 이어 단기물도 함께 뛰는 모습을 보이고 있습니다. 국고채 3년물 등 단기금리는 코픽스나 은행채 금리와 연동이 돼 있는데, 코픽스나 은행채는 통상 대출금리 등을 산정할 때 기준이 되고 있습니다. 총량 규모에서 은행권의 가계대출 규모가 1천조원을 넘어 어마어마한 수준이고, 상당수가 변동금리라는 점에서 최근 단기물 금리 급등에 대한 우려감도 적지 않습니다. 윤여삼 메리츠증권 연구원은 "단기금리는 만기가 짧아 다른 위험이 적은 대신 기준금리 연동성이 매우 높다"며 "현재 국내 기준금리 0.50% 대비 국고3년 금리가 1.2%까지 올라온 것은 과거 금리인상 직전에나 볼 수 있던 현상"이라고 분석하고 있습니다.
        
        <앵커>
        
        이베이코리아 매각을 위한 예비입찰이 다음주에 있습니다. 시기적으로 쿠팡 상장 등과 맞물려 관심을 받고 있습니다. 또 SK바이오사이언스도 내주 코스피에 상장합니다.
        
        <기자>
        
        쿠팡의 미국 뉴욕증권거래소 상장으로 국내 이커머스업체 등에 대한 기업가치 재평가가 일고 있습니다. 특히, 강한 경기회복 기대감 등과 맞물리면서 국내 유통주 전반으로도 기대감이 일고 있습니다. 이번 쿠팡 상장은 현재 5조원 가량으로 추정되는 이베이코리아 매각가에도 영향을 미칠 것으로 예상됩니다. 오는 18일에는 SK바이오사이언스의 코스피 상장이 예정돼 있습니다. 올해 상반기 IPO(기업공개) 시장 최대어로 꼽히면서 공모청약 금액만 64조원, 사상 최대 규모가 몰렸습니다. 균등배분방식이 도입돼 소액투자자도 최소 1~2주를 받도록 했는데, 일부 증권사의 경우 배정물량 대비 청약주수가 초과하면서 1주도 못받게 되는 상황도 벌어졌습니다. 상장 이후 어떤 주가 흐름을 보일지 관심입니다.`
    },
    {
        src: "https://imgnews.pstatic.net/image/366/2021/03/09/0000681572_001_20210309165430239.jpg",
        title: "[마켓뷰] 코스피, 이틀 연속 3000선 아래로...미 국채금리 급등 영향",
        date: '2021.03.09',
        description: `美국채금리 급등에 투자심리 악화
        KB금융 등 금융주는 2~5%상승 
        
        코스피지수가 이틀 연속 3000선을 내주며 하락 마감했다. 전날 미 나스닥지수가 금리 인상에 대한 우려감으로 크게 하락하자, 국내 증시에 대한 투자 심리도 영향을 받은 것으로 풀이된다.
        
        
        9일 오후 서울 중구 하나은행 본점 딜링룸의 모습. /연합뉴스
        
        9일 코스피지수는 전날보다 19.99포인트(0.67%) 하락한 2976.12로 마감했다.
        
        이날 하락장을 견인한 것은 외국인 투자자들의 매도세였다. 외국인은 유가증권시장에서 총 6462억원을 순매도했다. 반면 개인과 기관은 각각 3554억원, 2920억원을 순매수했다. 코스피지수는 오전 11시쯤 2920선대까지 내렸으나, 오후 들어 점차 낙폭을 축소하며 2970~2980선에서 횡보했다.
        
        프로그램 매매를 통해서도 3000억원 이상이 빠져나갔다. 총 3160억원이 순유출됐는데, 비차익거래가 3181억원 매도 우위를 기록했다. 차익거래는 21억원 매수 우위였다.
        
        시가총액 상위 종목들은 혼조세를 나타냈다. 유가증권시장 시가총액 1위 업체인 삼성전자(005930)는 전날보다 0.73% 하락한 8만1400원에 거래를 마쳤으며, LG화학(051910)과 NAVER(035420), 삼성바이오로직스(207940), 삼성SDI(006400), 카카오(035720)도 하락했다. 반면 SK하이닉스(000660)와 삼성전자우(005935), 현대차(005380), 기아차(000270)는 1% 안팎의 상승률을 기록했다.
        
        ◇ "미 증시에 동조...성장주 많은 나스닥 따라 하락"
        
        이날 외국인 투자자들이 국내 증시에서 대거 빠져나간 이유는 미 국채금리 상승에 대한 우려가 커진 데서 찾을 수 있다.
        
        8일(현지 시각) 미 국채 10년물 금리는 장중 한 때 1.606%까지 상승했다. 이는 미국의 대규모 부양책과 관계 있는 것으로 해석된다. 최근 미 상원에서 1조9000억달러 규모의 부양책을 가결하자, 연방준비제도(Fed·연준)의 국채 발행량이 증가할 것이라는 전망이 커졌다. 국채의 물량이 늘면 금리(할인율)가 높아지는 것이 일반적이다. 
        
        이러한 우려에서 비롯된 금리 상승세를 반영하듯, 성장주 중심으로 구성된 미 나스닥지수는 지난밤 크게 하락했다. 나스닥지수는 8일(현지 시각) 전날보다 2.41% 내린 1만2609.16에 마감했다. 테슬라는 전날보다 34.95포인트(5.84%) 내린 563달러에 거래를 마쳤다. 애플은 4.17%, 페이스북은 3.39% 하락했다. 
        
        반면 다우존스30산업평균지수는 0.97% 오른 3만1802.44에 거래를 마쳤다. 금융투자업계 관계자들은 나스닥과 다우존스의 엇갈린 등락이 최근의 금리 상승세를 반영한 결과라고 분석했다.
        
        정용택 IBK투자증권 리서치센터장은 "미 국채 금리가 오르면서 전기차 등 기술, 성장주 위주로 구성된 나스닥시장은 크게 하락한 반면, 다우존스는 금융주와 은행주 등 금리 상승 수혜주를 중심으로 상승했다"고 말했다.
        
        정 센터장은 국내 증시 역시 미 증시와 비슷한 흐름을 나타내고 있다고 설명했다. 성장주는 많이 하락한 반면, 금리 상승기에 혜택을 볼 수 있는 금융주는 상승했다는 것이다.
        
        실제로 이날 유가증권시장에서 금융주는 대체로 강세를 나타냈다. KB금융(105560)은 전날보다 5.31% 오른 5만2600원에 거래를 마쳤다. 한화손해보험(000370)은 4% 넘게 상승 마감했으며, 삼성화재(000810), 메리츠금융지주(138040), 하나금융지주(086790)가 모두 2%대의 상승률을 기록했다. 
        
        강봉주 메리츠증권 연구원은 "미국 채권 금리가 크게 오르자 밸류에이션(기업 가치 대비 주가)이 높은 성장주에 대한 투자 심리가 약해진 반면 상대적으로 안전한 가치주의 주가 흐름은 견조했다"며 "외국인 투자자 입장에서 볼 때 한국 증시는 위험 자산에 가까운 나스닥 시장과 비슷하기 때문에, 자금을 대거 빼낸 것으로 보인다"고 말했다.
        
        이 외에도 국채 금리 상승이 야기한 원화 약세가 외국인의 매도세를 가속화한 것으로 풀이된다. 미 국채 금리가 크게 오르며 미국과 한국의 금리 간 차이가 확대되자, 미 달러화 대비 원화 환율이 상승(원화 가치 하락)한 것이다. 이는 통상 외국인 투자자들의 자금 유출 요인으로 작용한다.
        
        이날 서울 외환시장에서 미 달러화 대비 원화 환율은 전날보다 7.1원 오른 1140.3원을 기록했다. 종가 기준으로 지난해 10월 19일(1142원) 이후 약 5개월만에 1140원을 넘어선 것이다.
        
        증권 업계 전문가들은 당분간 코스피지수의 약세가 해소되기 어려울 것으로 내다봤다. 오는 16~17일(현지 시각)로 예정된 미 연방공개시장위원회(FOMC)에서 연준이 금리 상승에 대한 적극적인 대응책을 내놓지 않을 가능성이 크다는 것이다. 제롬 파월 연준 이사회 의장은 지난 4일(현지 시각) 국채 금리 상승에 대해 개입하지 않겠다고 밝힌 바 있다. 
        
        ◇ 코스닥 1% 가까이 하락 마감
        
        이날 국내 주식시장에서는 코스피 뿐 아니라 코스닥지수도 큰 폭으로 하락 마감했다. 코스닥지수는 전날보다 8.41포인트(0.93%) 하락한 896.36에 마감했다. 코스닥지수가 900선을 내준 것은 지난해 12월 2일(장중 저점 891.61) 이후 약 3개월만이다.
        
        코스닥지수는 기관 투자자들의 매도세에 밀려 하락했다. 기관은 총 818억원을 순매도했다. 반면 개인과 외국인은 각각 5억원, 909억원을 순매수했다. 
        
        시가총액 상위 종목들은 혼조세를 나타냈다. 셀트리온헬스케어(091990), 셀트리온제약(068760), 카카오게임즈, 알테오젠(196170), 에코프로비엠은 하락 마감했다. 반면 씨젠(096530)과 SK머티리얼즈(036490)등은 상승했다.
        
        코스닥시장에 신규 상장한 나노 소재 개발 업체 나노씨엠에스는 시초가 대비 20% 넘게 급락했다. 나노씨엠에스는 이날 시초가(3만3000원) 대비 27.42% 낮은 2만3950원에 거래를 마감했다. 다만, 공모가(2만원)보다는 높은 가격에 거래를 마쳤다.`
    }
]

/*
export const Scrap = ({}) => {
    const [scrap, setScrap] = useState(false);
    return (
        <Col width="100vw" height="90vh" justify="flex-start">
            <Text weight="500" size="30" color="#FFA03B" margin="margin: 30px;">Financial Scraps</Text>
            <Col align="center" justify="center" margin="margin-top: 50px;">
                <Text weight="700" size="50" color="rgb(170,170,170)" margin="margin: 20px 0px;">Coming Soon</Text>
                <Text weight="700" size="30" color="rgb(170,170,170)" margin="margin: 10px 0px;">Website Plan</Text>
                <Text weight="700" size="20" color="rgb(170,170,170)" margin="margin: 10px 0px;">1. Scrap Section</Text>
                <Text weight="700" size="20" color="rgb(170,170,170)" margin="margin: 10px 0px;">2. Korea CD, CB, Future Compare Section</Text>
                <Text weight="700" size="20" color="rgb(170,170,170)" margin="margin: 10px 0px;">3. Daily Table Section</Text>
            </Col>
        </Col>
    )
}
*/

export const Scrap = ({}) => {
    const [on, setOn] = useState(false);
    const [scrap, setScrap] = useState(data[0]);
    return (
        <Col width="100%" justify="center">
            <Slide setOn={setOn} on={on} scrap={scrap} />
            <Image src={finance_scrap} height="35px" of="contain" margin="margin: 10px 0px; margin-top: 18px;" />
            <Col width="100%" align="center" justify="center" margin="margin-top: 20px;">
                <Row width="100%" height="100%" align="center">
                    {data.slice(0,4).map((item, index) => <ScrapBox setScrap={setScrap} index={index} on={on} setOn={setOn} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(4,8).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(8,12).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(12,16).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(16,20).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(20,24).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(24,28).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(28,32).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(32,36).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
                <Row width="100%" height="100%" align="center">
                    {data.slice(36,40).map((item, index) => <ScrapBox setScrap={setScrap} on={on} setOn={setOn} index={index} data={item} key={index}/>)}
                </Row>
            </Col>
        </Col>
    )
}

export default Scrap;